webpackJsonp([107],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BASE_URL */
/* unused harmony export FEED_MODULE */
/* unused harmony export feed */
/* unused harmony export camp */
/* unused harmony export faq */
/* unused harmony export topic */
/* unused harmony export rental */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var BASE_URL = '/api/rental/public';

var FEED_MODULE = '../../community/public';
var feed = {
  auth: FEED_MODULE + '/common/auth',
  list: FEED_MODULE + '/index/feed',
  detail: FEED_MODULE + '/post/info',
  add: FEED_MODULE + '/post/create',
  like: FEED_MODULE + '/post/credit',
  commentLike: FEED_MODULE + '/post/replyCredit',
  likeList: FEED_MODULE + '/post/creditList',
  adv: '/../../../static/mock/feed_home_adv.json',
  comments: FEED_MODULE + '/post/content',
  reply: FEED_MODULE + '/post/reply',
  follow: FEED_MODULE + '/relation/follow',
  delete: FEED_MODULE + '/post/del',
  myMessage: FEED_MODULE + '/notify/nlist',
  myFeed: FEED_MODULE + '/user/postlist',
  userFeed: FEED_MODULE + '/user/postlist',
  myFaq: FEED_MODULE + '/user/wdpostlist',
  myFans: FEED_MODULE + '/user/fans',
  newMessageNumber: FEED_MODULE + '/user/getUserNotifyNum',
  userInfo: FEED_MODULE + '/user/info',
  userFans: FEED_MODULE + '/user/fans',
  sendmsg: FEED_MODULE + '/common/sendmsg',
  checkMsg: FEED_MODULE + '/common/checkmsg',
  userFollow: FEED_MODULE + '/user/follow',
  down: FEED_MODULE + '/common/checkVersion',
  videosdk: FEED_MODULE + '/aliyun/vodPlaySts',
  myFlo: FEED_MODULE + '/user/followWdpost',
  topiclist: FEED_MODULE + '/topic/tlist',
  appCode: FEED_MODULE + '/common/getWebVersion',
  topicInfo: FEED_MODULE + '/topic/info',
  topicInfoList: FEED_MODULE + '/Topic/relatedList',
  advclick: FEED_MODULE + '/startadv/clickadv',
  circleHome: FEED_MODULE + '/circle/circle/home',
  circleList: FEED_MODULE + '/circle/circle/feeds'
};

var camp = {
  list: FEED_MODULE + '/camp/list',
  detail: FEED_MODULE + '/camp/info',
  imgList: FEED_MODULE + '/camp/imgList',
  putError: FEED_MODULE + '/camp/putError',
  collect: FEED_MODULE + '/camp/collect',
  myCamp: FEED_MODULE + '/camp/myCamp',
  replyList: FEED_MODULE + '/camp/replyList',
  replyCredit: FEED_MODULE + '/camp/replyCredit',
  reply: FEED_MODULE + '/camp/reply',
  replyInfo: FEED_MODULE + '/camp/replyInfo',
  share: FEED_MODULE + '/camp/shareCamp',
  comdel: FEED_MODULE + '/camp/delReply',
  code: FEED_MODULE + '/camp/getIdByCode'
};

var faq = {
  list: FEED_MODULE + '/wdpost/feed',
  detail: FEED_MODULE + '/wdpost/info',
  add: FEED_MODULE + '/wdpost/create',
  comments: FEED_MODULE + '/wdpost/content',
  tags: FEED_MODULE + '/topic/tlist',
  follow: FEED_MODULE + '/wdpost/follow',
  reply: FEED_MODULE + '/wdpost/reply',
  digg: FEED_MODULE + '/wdpost/digg',
  search: FEED_MODULE + '/wdpost/search'
};

var topic = {
  list: FEED_MODULE + '/topic/tlist',
  detail: FEED_MODULE + '/topic/index',
  feed: FEED_MODULE + '/topic/posts'
};

var rental = {
  auth: FEED_MODULE + '/common/auth',
  account: FEED_MODULE + '/common/auth',
  upload: '/common/upload',
  common: {
    currentLocation: '/city/city/getCode' },
  order: {
    submit: '/Account/Login',
    list: '/user/order/list',
    detail: '/order/order/find',
    cancel: '/common/valicode',
    find: '/user/order/find',
    log: '/User/Account/validateTel',
    sign: 'pay/pay/payorder'
  },
  adv: {
    list: '/adv/adv/list',
    detail: '/',
    hotCity: '/topcontent/topcontent/find',
    hotRv: '/'
  },
  rv: {
    list: '/rv/rv/list',
    detail: '/rvcomment/rvcomment/list',
    info: '/rv/rv/find',
    fee: '/rvinfo/rvinfo/find',
    find: '/rvcomment/rvcomment/find',
    add: '/user/rvcomment/add',
    dateprice: '/rvdateprice/rvdateprice/list',
    hotlist: '/rv/rv/hotLists',
    wxcode: '/common/wechatSign',
    hotStoreList: '/rv/rv/hotAgencylist'
  },
  comment: {
    list: '/',
    detail: '/user/answer/add',
    add: '/order/order/add'
  },
  store: {
    detail: '/store/store/find',
    server: '/store/store/extraList',
    list: '/store/store/goodsList'
  },
  city: {
    list: '/city/city/list',
    forReturn: '/rvtakeback/rvtakeback/list'
  },
  user: {
    list: '/User/User/find',
    detail: '/User/User/find',
    add: '/user/answer/add',
    remove: '/user/order/cancel',
    register: '/common/sendcode',
    useradd: '/User/Account/add',
    detection: '/User/Account/validateTel',
    fastlogin: '/Account/fastLogin',
    update: FEED_MODULE + '/user/setting',
    updAvatar: '/User/User/updAvatar',
    updatePwd: '/User/User/updatePwd',
    wechatLogin: '/User/Account/wechatLogin',
    wechatAuth: '/User/Account/wechatAuth',
    bindTel: FEED_MODULE + '/user/bangtel',
    bindWechat: FEED_MODULE + '/user/bangwechat',
    notifyNum: FEED_MODULE + '/user/getUserNotifyNum',
    notifyList: FEED_MODULE + '/notify/nlist',
    brandList: FEED_MODULE + '/common/brandList',
    modelList: FEED_MODULE + '/common/rvTypeList',
    carCertify: FEED_MODULE + '/user/authRv',
    editCertify: FEED_MODULE + '/user/editAuthRv',
    detailCertify: FEED_MODULE + '/user/rvInfo',
    discounts: '/user/user/myCoupon'
  },
  pay: {
    open: '/Pay/Pay/getunionid',
    pay: '/Pay/Pay/payment'
  },
  agency: {
    home: '/agency/index',
    list: '/agency/rvList',
    find: '/agency/find',
    citylist: '/agency/cityList'
  },
  discounts: {
    get: '/coupon/detailInfo',
    detail: '/coupon/info',
    list: '/coupon/list',
    add: '/coupon/add',
    det_list: '/coupon/detailList'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  BASE_URL: BASE_URL,
  FEED_MODULE: FEED_MODULE
}, rental, {
  feed: feed,
  faq: faq,
  topic: topic,
  camp: camp
}));

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AUTH_TOKEN_KEY */
/* unused harmony export CURRENT_CITY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* unused harmony export getters */
/* unused harmony export actions */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_date_today__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_date_today___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tools_date_today__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_feed__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_jwt__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tools_util__ = __webpack_require__(37);



var _mutations;











__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var AUTH_TOKEN_KEY = 'WFC_AUTH_TOKEN';
var CURRENT_CITY = 'CURRENT_CITY';
var state = {
  token: window.localStorage.getItem(AUTH_TOKEN_KEY),
  currentCity: window.localStorage.getItem(CURRENT_CITY),
  messageData: {
    pickup_city: '北京市',
    return_city: '北京市',
    pickup_id: 110100,
    return_id: 110100,
    pickup_datetime: __WEBPACK_IMPORTED_MODULE_4__tools_date_today___default()(0) + ' 10:00',
    return_datetime: __WEBPACK_IMPORTED_MODULE_4__tools_date_today___default()(6) + ' 18:00'
  },
  query: {
    pickup_city: '北京市',
    return_city: '北京市',
    pickup_id: 110100,
    return_id: 110100,
    pickup_datetime: __WEBPACK_IMPORTED_MODULE_4__tools_date_today___default()(0) + ' 10:00',
    return_datetime: __WEBPACK_IMPORTED_MODULE_4__tools_date_today___default()(1) + ' 10:00'
  },
  cityList: null,
  cityPick: false,
  navigation: null,
  feedList: null,
  is_app: window.localStorage.getItem('IS_APP') || 0,
  openid: null
};

var getters = {
  token: function token(state) {
    return state.token;
  },
  is_app: function is_app(state) {
    return state.is_app;
  },

  currentUser: function currentUser(state) {
    return __WEBPACK_IMPORTED_MODULE_7__tools_jwt__["a" /* default */].payload(window.localStorage.getItem(AUTH_TOKEN_KEY)) || {};
  },

  isLoggedin: function isLoggedin(state) {
    return window.localStorage.getItem(AUTH_TOKEN_KEY) || false;
  },
  isAgency: function isAgency(state) {
    return __WEBPACK_IMPORTED_MODULE_7__tools_jwt__["a" /* default */].payload(state.token) && __WEBPACK_IMPORTED_MODULE_7__tools_jwt__["a" /* default */].payload(state.token).status === '3';
  },
  currentCity: function currentCity(state) {
    return state.currentCity && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tools_util__["b" /* isJson */])(state.currentCity) ? JSON.parse(state.currentCity) : { city: '北京市', cityid: '110100' };
  },
  cityList: function cityList(state) {
    return state.cityList;
  },
  query: function query(state) {
    return state.query;
  },
  cityPick: function cityPick(state) {
    return state.cityPick;
  },
  feedList: function feedList(state) {
    return state.feedList;
  },
  navigation: function navigation(state) {
    return state.navigation;
  }
};

var actions = {
  saveToken: function saveToken(_ref, _ref2) {
    var commit = _ref.commit;
    var token = _ref2.token;

    if (__WEBPACK_IMPORTED_MODULE_7__tools_jwt__["a" /* default */].valid(token)) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* SAVE_TOKEN */], { token: token });
      return true;
    } else {
      return false;
    }
  },
  setIsApp: function setIsApp(_ref3, str) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* SET_IS_APP */], str);
  },
  clearToken: function clearToken(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* CLEAR_TOKEN */]);
  },
  saveCurrentCity: function saveCurrentCity(_ref5, city) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* SAVE_CURRENT_CITY */], city);
  },
  doLogout: function doLogout(_ref6) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* CLEAR_TOKEN */]);
  },
  saveCityList: function saveCityList(_ref7, _ref8) {
    var commit = _ref7.commit;
    var list = _ref8.list;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* SAVE_CITY_LIST */], { list: list });
  },
  saveQuery: function saveQuery(_ref9, _ref10) {
    var commit = _ref9.commit;
    var query = _ref10.query;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* SAVE_QUERY */], { query: query });
  },
  saveCityPick: function saveCityPick(_ref11, _ref12) {
    var commit = _ref11.commit;
    var cityPick = _ref12.cityPick;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* SAVE_CITY_PICK */], { cityPick: cityPick });
  },
  saveFeedList: function saveFeedList(_ref13, list) {
    var commit = _ref13.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SAVE_FEED_LIST */], list);
  },
  saveNavigation: function saveNavigation(_ref14, _ref15) {
    var commit = _ref14.commit;
    var list = _ref15.list;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* SAVE_NAVIGATION */], { list: list });
  },
  saveOpenid: function saveOpenid(_ref16, _ref17) {
    var commit = _ref16.commit;
    var openid = _ref17.openid;

    commit('SAVE_OPENID', { openid: openid });
  }
};

var mutations = (_mutations = {
  SAVE_OPENID: function SAVE_OPENID(state, _ref18) {
    var openid = _ref18.openid;

    state.openid = openid;
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* CLEAR_TOKEN */], function (state) {
  window.localStorage.removeItem(AUTH_TOKEN_KEY);
  state.token = '';
  state.isLoggedin = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* SAVE_TOKEN */], function (state, _ref19) {
  var token = _ref19.token;

  window.localStorage.setItem(AUTH_TOKEN_KEY, token);
  state.token = token;
  state.isLoggedin = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* SAVE_CURRENT_CITY */], function (state, city) {
  state.currentCity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(city);
  window.localStorage.setItem(CURRENT_CITY, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(city));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* SAVE_CITY_LIST */], function (state, _ref20) {
  var list = _ref20.list;

  state.cityList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* SAVE_QUERY */], function (state, _ref21) {
  var query = _ref21.query;

  state.query = query;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* SAVE_CITY_PICK */], function (state, _ref22) {
  var cityPick = _ref22.cityPick;

  state.cityPick = cityPick;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SAVE_FEED_LIST */], function (state, list) {
  state.feedList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* SAVE_NAVIGATION */], function (state, _ref23) {
  var list = _ref23.list;

  state.navigation = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* SET_IS_APP */], function (state, res) {
  window.localStorage.setItem('IS_APP', res);
  state.is_app = res;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  modules: {
    feed: __WEBPACK_IMPORTED_MODULE_6__modules_feed__["a" /* default */]
  },
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HOME_BANNER_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WECHAT_ZUCHE_PAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WECHAT_RENTAL_PAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ossimage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return topics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return maptype; });

var HOME_BANNER_IMAGE = 'https://img01.wanfangche.com/public/upload/201710/26/1508995567554.jpg?x-oss-process=style/large';
var WECHAT_ZUCHE_PAY = 'https://api.wanfangche.com/rental/public/Pay/Pay/getunionid?url=https://m.wanfangche.com/pay/wechat/?id=';
var WECHAT_RENTAL_PAY = 'https://api.wanfangche.com/rental/public/Pay/Pay/getunionid?url=https://m.wanfangche.com/pay/wechat/?id=';

var ossimage = {
  avatar: '?x-oss-process=style/avatar',
  small: '?x-oss-process=style/small',
  middle: '?x-oss-process=style/middle',
  squareLarge: '?x-oss-process=style/square-large',
  large: '?x-oss-process=style/large',
  xlarge: '_ytsy'
};

var topics = ['房车家族英雄会', '英雄会摄影大赛', '2018逛房车展', '随手拍房车', '旅行故事', '露营生活', '目的地推荐'];

var maptype = [{ value: 100000, name: '住宿服务' }, { value: 100100, name: '宾馆酒店' }, { value: 100101, name: '六星级以上宾馆' }, { value: 100102, name: '五星级宾馆' }, { value: 100103, name: '四星级宾馆' }, { value: 100104, name: '三星级宾馆' }, { value: 100105, name: '经济型连锁酒店' }, { value: 100200, name: '旅馆招待所' }, { value: 100201, name: '青年旅舍' }, { value: 110000, name: '旅游景点' }, { value: 110100, name: '公园广场' }, { value: 110101, name: '公园' }, { value: 110102, name: '动物园' }, { value: 110103, name: '植物园' }, { value: 110104, name: '水族馆' }, { value: 110105, name: '城市广场' }, { value: 110200, name: '风景名胜' }, { value: 110201, name: '世界遗产' }, { value: 110202, name: '国家级景点' }, { value: 110203, name: '省级景点' }, { value: 110204, name: '纪念馆' }, { value: 110205, name: '寺庙道观' }, { value: 110206, name: '教堂' }, { value: 110207, name: '回教寺' }, { value: 110208, name: '海滩' }, { value: 140000, name: '科教文化场所' }, { value: 140100, name: '博物馆' }, { value: 140101, name: '奥迪博物馆' }, { value: 140102, name: '奔驰博物馆' }, { value: 140200, name: '展览馆' }, { value: 140300, name: '会展中心' }, { value: 140400, name: '美术馆' }, { value: 140500, name: '图书馆' }, { value: 140600, name: '科技馆' }, { value: 140700, name: '天文馆' }, { value: 140800, name: '文化宫' }, { value: 140900, name: '档案馆' }, { value: 141000, name: '文艺团体' }, { value: 141100, name: '传媒机构' }, { value: 141101, name: '电视台' }, { value: 141102, name: '电台' }, { value: 141103, name: '报社' }, { value: 141104, name: '杂志社' }, { value: 141105, name: '出版社' }, { value: 141200, name: '学校' }, { value: 141201, name: '高等院校' }, { value: 141202, name: '中学' }, { value: 141203, name: '小学' }, { value: 141204, name: '幼儿园' }, { value: 141205, name: '成人教育' }, { value: 141206, name: '职业技术学校' }, { value: 141300, name: '科研机构' }, { value: 141400, name: '培训机构' }, { value: 141500, name: '驾校' }, { value: 180000, name: '道路附属设施' }, { value: 180100, name: '警示信息' }, { value: 180101, name: '摄像头' }, { value: 180102, name: '测速设施' }, { value: 180103, name: '铁路道口' }, { value: 180200, name: '收费站' }, { value: 180201, name: '高速收费站' }, { value: 180202, name: '国省道收费站' }, { value: 180203, name: '桥洞收费站' }, { value: 180300, name: '高速服务区' }, { value: 180301, name: '高速加油站服务区' }, { value: 180302, name: '高速停车区' }, { value: 180400, name: '红绿灯' }, { value: 180500, name: '路牌信息' }, { value: 190000, name: '地名地址信息' }, { value: 190100, name: '行政地名' }, { value: 190101, name: '国家名' }, { value: 190102, name: '省' }, { value: 190103, name: '直辖市' }, { value: 190104, name: '地市' }, { value: 190105, name: '区县' }, { value: 190106, name: '乡镇' }, { value: 190107, name: '街道' }, { value: 190108, name: '村庄' }, { value: 190109, name: '村组' }, { value: 190200, name: '自然' }, { value: 190201, name: '海湾' }, { value: 190202, name: '岛屿' }, { value: 190203, name: '山' }, { value: 190204, name: '河流' }, { value: 190205, name: '湖泊' }, { value: 190300, name: '地名' }, { value: 190301, name: '道路' }, { value: 190302, name: '路口' }, { value: 190303, name: '环岛名' }, { value: 190304, name: '高速路出口' }, { value: 190305, name: '高速路入口' }, { value: 190306, name: '立交桥' }, { value: 190307, name: '桥' }, { value: 190308, name: '城市快速路出口' }, { value: 190309, name: '城市快速路入口' }, { value: 190310, name: '隧道' }, { value: 190400, name: '门牌' }, { value: 190401, name: '地名门牌' }, { value: 190402, name: '道路门牌' }, { value: 190403, name: '小区门牌' }, { value: 190500, name: '城市中心' }, { value: 190600, name: '标志性建筑物' }, { value: 200000, name: '公共设施' }, { value: 200100, name: '报刊亭' }, { value: 200200, name: '公用电话' }, { value: 200300, name: '公共厕所' }, { value: 200400, name: '紧急避难场所' }];

/* harmony default export */ __webpack_exports__["a"] = ({
  HOME_BANNER_IMAGE: HOME_BANNER_IMAGE,
  WECHAT_ZUCHE_PAY: WECHAT_ZUCHE_PAY,
  WECHAT_RENTAL_PAY: WECHAT_RENTAL_PAY,
  ossimage: ossimage,
  feedShareAddon: ' | 21世纪房车',
  feedShareImage: 'https://img01.wanfangche.com/public/upload/201711/09/5a03c7697580d.jpg?x-oss-process=style/small',
  maptype: maptype
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObject */
/* harmony export (immutable) */ __webpack_exports__["b"] = isJson;
/* harmony export (immutable) */ __webpack_exports__["d"] = looseEqual;
/* unused harmony export looseIndexOf */
/* unused harmony export startsWith */
/* harmony export (immutable) */ __webpack_exports__["a"] = getQuery;
/* harmony export (immutable) */ __webpack_exports__["c"] = wxShares;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk__);



function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) === 'object';
}

function isJson(str) {
  if (str && str !== null && typeof str === 'string') {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  } else {
    return false;
  }
}

function looseEqual(a, b) {
  return a == b || (isObject(a) && isObject(b) ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(a) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(b) : false);
}

function looseIndexOf(arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) {
      return i;
    }
  }

  return -1;
}

function startsWith(string, query) {
  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  return string.substr(position, query.length) === query;
}

function getQuery(link, name) {
  if (link) {
    var reg = new RegExp('(^|)' + name + '=([^&]*)(&|$)');
    var r = link.match(reg);
    if (r !== null) return unescape(r[2]);else return null;
  }
}


function wxShares(data) {
  __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.ready(function () {
    __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.onMenuShareAppMessage({
      title: data.title,
      desc: data.desc,
      link: data.link,
      imgUrl: data.imgUrl,
      success: function success(res) {},
      cancel: function cancel(res) {}
    });

    __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.onMenuShareTimeline({
      title: data.title + '|' + data.desc,
      link: data.link,
      imgUrl: data.imgUrl,
      success: function success(res) {},
      cancel: function cancel(res) {}
    });
  });
}

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isSmartDevice */
/* harmony export (immutable) */ __webpack_exports__["a"] = isWechat;
/* harmony export (immutable) */ __webpack_exports__["b"] = isIOS;

function isSmartDevice() {
  var ua = window['navigator']['userAgent'] || window['navigator']['vendor'] || window['opera'];

  return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/.test(ua)
  );
}

function isWechat() {
  var ua = window['navigator']['userAgent'] || window['navigator']['vendor'] || window['opera'];
  var str = /MicroMessenger/.test(ua) || /NewsArticle/.test(ua);
  return str;
}

function isIOS() {
  var ua = window['navigator']['userAgent'] || window['navigator']['vendor'] || window['opera'];
  return (/iPhone|iPod|iPad/.test(ua)
  );
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  isSmartDevice: isSmartDevice,
  isWechat: isWechat,
  isIOS: isIOS
});

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = function (date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

  if (!date) {
    return '';
  }
  if (typeof date === 'string') {
    date = new Date(date.replace(/-/g, '/'));
  }
  if (typeof date === 'number') {
    date = new Date(date);
  }
  var o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  var week = {
    '0': '\u65E5',
    '1': '\u4E00',
    '2': '\u4E8C',
    '3': '\u4E09',
    '4': '\u56DB',
    '5': '\u4E94',
    '6': '\u516D'
  };
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? '\u661F\u671F' : '\u5468' : '') + week[date.getDay() + '']);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (str) {
  var rel = str;

  rel = rel.replace(/#([^#|.]+)#/g, function (word) {
    return '<span class="feed_content_tag" tag="' + word.replace(/#/g, '') + '">' + word + '</span>';
  });

  rel = rel.replace(/@[^ :：#@]+/g, function (word) {
    return '<span class="feed_content_tag" ">' + word + '</span>';
  });

  return rel;
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(9);





var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].BASE_URL,
  headers: {
    'device-type': '3',
    'version': '2.0.5'
  }
});

instance.interceptors.request.use(function (config) {
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.token) {
    config.headers.Authorization = '' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.token;
  }
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

instance.auth = instance.get(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].auth).then(function (response) {
  if (response.data.code === 200 && response.headers.authorization) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('saveToken', { token: response.headers.authorization });
  } else {}
});

instance.upload = function (file) {
  var axiosConfig = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
      'Authorization': '' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.token
    }
  };
  var formdata = new window.FormData();

  if (file.length > 1) {
    for (var index in file) {
      formdata.append('file[]', file[index]);
    }
  } else {
    formdata.append('file', file);
  }
  return instance.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upload, formdata, axiosConfig);
};

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (val) {
  if (val === 0) {
    return '停车场';
  } else if (val === 1) {
    return '标准营地';
  } else if (val === 2) {
    return '景点';
  } else if (val === 3) {
    return '美食';
  } else if (val === 4) {
    return '修理厂';
  } else if (val === 5) {
    return '加气';
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (val) {
  var str = '';
  if (val > 1000) {
    str = val / 1000;
    str = str.toFixed(1) + 'km';
  } else {
    str = val + 'm';
  }
  return str;
});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {module.export = function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB';
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB';
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB';
  }
  return size.toString() + ' B';
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(316)(module)))

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(36);

var style = __WEBPACK_IMPORTED_MODULE_0__config__["c" /* ossimage */];

/* harmony default export */ __webpack_exports__["a"] = (function (url, size) {
  return style[size] ? url + style[size] : url + style.large;
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function (val) {
  var arr = [1, 2, 3];
  console.log(arr.length);
  for (var key in arr) {
    console.log(arr, key);

    return '';
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_feed_home__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_feed_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_feed_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rental__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__feed__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__demo_routes__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_preview__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__);





var Login = function Login(resolve) {
  return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(336)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Register = function Register(resolve) {
  return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(347)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NotFound = function NotFound(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(125)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_preview___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/',
  routes: [__WEBPACK_IMPORTED_MODULE_8__demo_routes__["default"], __WEBPACK_IMPORTED_MODULE_5__user__["a" /* default */]].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__rental__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__feed__["a" /* default */]), [{
    path: '/collection',
    component: function component() {
      return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 391));
    },
    name: 'cms_collection'
  }, {
    path: '/login',
    component: Login,
    name: 'user_login'
  }, {
    path: '/register',
    component: Register,
    name: 'user_register'
  }, {
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_4__views_feed_home___default.a,
    meta: { keepAlive: true }
  }, { path: '*', component: NotFound }])
});


router.beforeEach(function (to, from, next) {
  if (to.path) {
    if (window.RV) {
      window.RV.sendEvent(null, { pg: '/#' + to.fullPath });
    }
  }

  if (to.matched.some(function (record) {
    return record.meta.requireAuth;
  }) && !__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.token) {
    next({
      path: '/login',
      query: { from: to.fullPath }
    });
  } else {
    next();
  }
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(249)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(294),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(247)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(291),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_price__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_price___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calendar_price__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__city_picker__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__city_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__city_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calendar__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loading_car__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loading_car___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loading_car__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loading_dot_move__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loading_dot_move___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loading_dot_move__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__upload_album__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__upload_album___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__upload_album__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__video_view__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__video_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__video_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__image_group__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__image_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__image_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__text_view__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__text_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__text_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gender__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gender___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__gender__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__emoji__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__emoji___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__emoji__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__file_upload__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__aliplay__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__aliplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__aliplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__camp_code__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__camp_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__camp_code__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__modal___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_3__calendar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__calendar_price___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__city_picker___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__loading_car___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__upload_album___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__loading_dot_move___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__video_view___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__image_group___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__text_view___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__gender___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__emoji___default.a; });
/* unused harmony reexport FileUpload */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_13__aliplay___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__camp_code___default.a; });
































/* unused harmony default export */ var _unused_webpack_default_export = ({
  Calendar: __WEBPACK_IMPORTED_MODULE_3__calendar___default.a,
  CalendarPrice: __WEBPACK_IMPORTED_MODULE_1__calendar_price___default.a,
  CityPicker: __WEBPACK_IMPORTED_MODULE_2__city_picker___default.a,
  Modal: __WEBPACK_IMPORTED_MODULE_0__modal___default.a,
  Loading: __WEBPACK_IMPORTED_MODULE_4__loading_car___default.a,
  AlbumUpload: __WEBPACK_IMPORTED_MODULE_6__upload_album___default.a,
  LoadingDotMove: __WEBPACK_IMPORTED_MODULE_5__loading_dot_move___default.a,
  VideoView: __WEBPACK_IMPORTED_MODULE_7__video_view___default.a,
  ImageGroup: __WEBPACK_IMPORTED_MODULE_8__image_group___default.a,
  TextView: __WEBPACK_IMPORTED_MODULE_9__text_view___default.a,
  Gender: __WEBPACK_IMPORTED_MODULE_10__gender___default.a,
  Emoji: __WEBPACK_IMPORTED_MODULE_11__emoji___default.a,
  FileUpload: __WEBPACK_IMPORTED_MODULE_12__file_upload___default.a,
  AliPlay: __WEBPACK_IMPORTED_MODULE_13__aliplay___default.a,
  CampCode: __WEBPACK_IMPORTED_MODULE_14__camp_code___default.a
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(238)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(239)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var Format = __webpack_require__(56);

module.exports = function () {
  var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

  var date = new Date().getTime();

  if (typeof d === 'number') date += d * 24 * 60 * 60 * 1000;

  return Format(date, fmt);
};

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var rs = function rs(path) {
  return function (resolve) {
    return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(423)("./" + path)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  path: '/demo',
  component: rs('index'),
  children: [{
    path: '',
    component: rs('home'),
    name: 'demo'
  }, {
    path: 'position',
    component: rs('position'),
    name: 'position'
  }, {
    path: 'image-group',
    component: rs('image-group'),
    name: 'image-group'
  }, {
    path: 'feed',
    component: rs('feed'),
    name: 'demo-feed'
  }, {
    path: 'feed/:id/detail',
    component: rs('feed-detail'),
    name: 'demo-feed-detail'
  }, {
    path: 'go-back',
    component: rs('go-back'),
    name: 'go-back'
  }, {
    path: 'page',
    component: rs('page'),
    name: 'demo-page'
  }, {
    path: 'page-detail',
    component: rs('page-detail'),
    name: 'page-detail'
  }, {
    path: 'location',
    component: rs('location'),
    name: 'location'
  }, {
    path: 'wechat-share',
    component: rs('wechat-share'),
    name: 'wechat-share'
  }, {
    path: 'upload',
    component: rs('upload'),
    name: 'upload'
  }, {
    path: 'sample-upload',
    component: rs('sample-upload'),
    name: 'sample-upload'
  }, {
    path: 'album-upload',
    component: rs('album-upload'),
    name: 'album-upload'
  }, {
    path: 'calendar',
    component: rs('calendar'),
    name: 'calendar'
  }, {
    path: 'calendar-price',
    component: rs('calendar-price'),
    name: 'calendar-price'
  }, {
    path: 'city-picker',
    component: rs('city-picker'),
    name: 'city-picker'
  }, {
    path: 'input-value',
    component: rs('input-value'),
    name: 'input-value'
  }, {
    path: 'loading',
    component: rs('loading'),
    name: 'loading'
  }, {
    path: 'modal',
    component: rs('modal'),
    name: 'modal'
  }, {
    path: 'popup',
    component: rs('popup'),
    name: 'popup'
  }, {
    path: 'scroll-refresh',
    component: rs('scroll-refresh'),
    name: 'scroll-refresh'
  }, {
    path: 'video',
    component: rs('video'),
    name: 'video'
  }, {
    path: 'swiper',
    component: rs('swiper'),
    name: 'swiper'
  }, {
    path: 'map',
    component: rs('map'),
    name: 'map'
  }, {
    path: 'amap',
    component: rs('amap'),
    name: 'amap'
  }]
});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(237)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(235)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(246)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(240)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(242)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(284),
  /* scopeId */
  "data-v-6ab13698",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(243)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(234)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(270),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(233)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_plugins_loading_index_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_amap__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_amap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_amap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lib_flexible__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lib_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lib_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters_oss_resize__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters_format_size__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters_format_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__filters_format_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filters_camp_type__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filters_distance__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__filters_serach_type__ = __webpack_require__(91);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vux_src_plugins_loading_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_amap___default.a);

__WEBPACK_IMPORTED_MODULE_7_vue_amap___default.a.initAMapApiLoader({

  key: '1f5bb764839780ea3e025d33cd657585',

  plugin: ['Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'ToolBar', 'MapType', 'PolyEditor', 'CircleEditor', 'Geolocation', 'Geocoder'],
  v: '1.4.4'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('ossResize', __WEBPACK_IMPORTED_MODULE_10__filters_oss_resize__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatSize', __WEBPACK_IMPORTED_MODULE_11__filters_format_size___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('camptype', __WEBPACK_IMPORTED_MODULE_12__filters_camp_type__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('distance', __WEBPACK_IMPORTED_MODULE_13__filters_distance__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('searchtype', __WEBPACK_IMPORTED_MODULE_14__filters_serach_type__["a" /* default */]);

var VueTouch = __webpack_require__(96);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(VueTouch, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.axios = __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */];

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  axios: __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_5__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/add_feed',
  component: function component() {
    return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 402));
  },
  name: 'feed_add',
  meta: { requireAuth: true }
}, {
  path: '/feedCircle',
  component: function component() {
    return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 389));
  },
  name: 'feed_circle',
  meta: { keepAlive: true }
}, {
  path: '/feed',
  component: function component() {
    return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 406));
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 126));
    },
    name: 'feed',
    meta: { keepAlive: true }
  }, {
    path: 'home',
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 86));
    },
    name: 'feed_home',
    meta: { keepAlive: true }
  }, {
    path: 'follow',
    component: function component() {
      return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 405));
    },
    name: 'feed_follow',
    meta: { keepAlive: true }
  }, {
    path: 'used',
    component: function component() {
      return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 412));
    },
    name: 'feed_used',
    meta: { keepAlive: true }
  }, {
    path: 'hot',
    component: function component() {
      return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 126));
    },
    name: 'feed_hot',
    meta: { keepAlive: true }
  }, {
    path: 'topic/:t_id',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 128));
    },

    name: 'feed_topic'
  }, {
    path: '/topicinfo',
    component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 128));
    },
    name: 'feed_topicinfo'
  }, {
    path: '/topicdetail',
    component: function component() {
      return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 410));
    },
    name: 'feed_topicdetail'
  }, {
    path: 'k/:key',
    component: function component() {
      return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 411));
    },
    name: 'feed_topic_redirect'
  }, {
    path: 'u/:u_id',
    component: function component() {
      return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 413));
    },
    name: 'feed_user',
    meta: { keepAlive: true }
  }, {
    path: 'list',
    component: function component() {
      return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 407));
    },
    name: 'feed_list',
    meta: { keepAlive: true }
  }, {
    path: ':id/detail',
    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 404));
    },
    name: 'feed_detail'
  }, {
    path: ':id/thumup',
    component: function component() {
      return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 409));
    },
    name: 'feed_thumb'
  }, {
    path: ':id/album',
    component: function component() {
      return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 403));
    },
    name: 'feed_album'
  }, {
    path: 'message',
    component: function component() {
      return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 408));
    },
    name: 'feed_message'
  }]
}, {
  path: '/faq',
  component: function component() {
    return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 400));
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 399));
    },
    name: 'faq'
  }, {
    path: 'list',
    component: function component() {
      return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 326));
    },
    name: 'faq_list'
  }, {
    path: 'add',
    component: function component() {
      return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 324));
    },
    name: 'faq_add',
    meta: { requireAuth: true }
  }, {
    path: ':id/detail',
    component: function component() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 325));
    },
    name: 'faq_detail'
  }, {
    path: ':id/album',
    component: function component() {
      return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 398));
    },
    name: 'faq_album'
  }, {
    path: 'search',
    component: function component() {
      return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 401));
    },
    name: 'faq_search'
  }]
}, {
  path: '/camp',
  component: function component() {
    return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 384));
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 383));
    },
    name: 'camp'
  }, {
    path: 'search',
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 387));
    },
    name: 'camp_search'
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 382));
    },
    name: 'camp_detail'
  }, {
    path: 'recovery/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 386));
    },
    name: 'camp_recovery'
  }, {
    path: 'comment/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 381));
    },
    name: 'camp_comment'
  }, {
    path: 'list/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 385));
    },
    name: 'comment_list'
  }, {
    path: 'upimg/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 379));
    },
    name: 'add_img'
  }, {
    path: 'info/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 380));
    },
    name: 'comment-info'
  }, {
    path: 'share',
    component: function component() {
      return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 388));
    },
    name: 'camp_share'
  }]
}, {
  path: '/browser',
  component: function component() {
    return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 323));
  },
  name: 'browser'
}, {
  path: '/amap',
  component: function component() {
    return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 331));
  },
  name: 'allAmap'
}, {
  path: '/topic',
  component: function component() {
    return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 415));
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 414));
    },
    name: 'topic'
  }, {
    path: 'k/:key',
    component: function component() {
      return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 416));
    },
    name: 'topic_key'
  }, {
    path: ':id',
    component: function component() {
      return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 417));
    },
    name: 'topic_feed'
  }]
}, {
  path: '/ufans/:u_id',
  component: function component() {
    return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 418));
  },
  name: 'u_fans'
}, {
  path: '/ufollow/:u_id',
  component: function component() {
    return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 420));
  },
  name: 'u_follow'
}, {
  path: '/u/:u_id',
  component: function component() {
    return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 422));
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 421));
    },
    name: 'u_home'
  }, {
    path: 'feed/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 419));
    },
    name: 'u_feed_detail'
  }]
}]);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(18);



/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/agreement',
  component: function component() {
    return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 360));
  },
  name: 'agreement'
}, {
  path: '/download',
  component: function component() {
    return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 395));
  },
  name: 'download'
}, {
  path: '/city',
  component: function component() {
    return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 328));
  },
  name: 'city'
}, {
  path: '/rental',
  component: function component() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 332));
  },
  name: 'rental'
}, {
  path: '/refreshs',
  component: function component() {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 322));
  },
  name: 'refresh'
}, {
  path: '/err',
  component: function component() {
    return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 125));
  },
  name: 'err'
}, {
  path: '/cost/',
  component: function component() {
    return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 392));
  },
  name: 'cost'
}, {
  path: '/errempty',
  component: function component() {
    return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 396));
  },
  name: 'errempty'
}, {
  path: '/errnothing',
  component: function component() {
    return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 397));
  },
  name: 'errnothing'
}, {
  path: '/list',
  component: function component() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 335));
  },
  name: 'list'
}, {
  path: '/pay',
  component: function component() {
    return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 346));
  },
  children: [{
    path: 'wechat',
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 345));
    },
    name: 'pay_wechat'
  }, {
    mode: 'history',
    path: 'alipay',
    component: function component() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 344));
    },
    name: 'pay_alipay'
  }]
}, {
  path: '/rv/:id',
  component: function component() {
    return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 353));
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 351));
    },
    name: 'rv_detail'
  }, {
    path: 'comment',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 350));
    },
    name: 'rv_comment'
  }, {
    path: 'meta',
    component: function component() {
      return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 352));
    },
    name: 'rv_meta'
  }, {
    path: 'album',
    component: function component() {
      return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 348));
    },
    name: 'rv_album'
  }, {
    path: 'book',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 349));
    },
    name: 'rv_book',
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.isLoggedin) {
        next({
          name: 'rv_detail',
          query: to.query,
          params: to.params
        });
      } else {
        next();
      }
    }
  }]
}, {
  path: '/comment/:id',
  component: function component() {
    return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 330));
  },
  name: 'comment',
  children: [{
    path: 'album',
    component: function component() {
      return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 329));
    },
    name: 'comment_album'
  }]
}, {
  path: '/order/:id',
  component: function component() {
    return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 342));
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 339));
    },
    name: 'order_detail'
  }, {
    path: 'comment',
    component: function component() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 338));
    },
    name: 'order_comment'
  }, {
    path: 'pay',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 341));
    },
    name: 'order_pay'
  }, {
    path: 'evaluate',
    component: function component() {
      return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 340));
    },
    name: 'order_evaluate'
  }]
}, {
  path: '/open_order',
  component: function component() {
    return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 337));
  },
  name: 'open_order'
}, {
  path: '/store/:id',
  component: function component() {
    return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 354));
  },
  name: 'store'
}, {
  path: '/agency/:id',
  component: function component() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 378));
  },
  name: 'agency'
}, {
  path: '/page',
  component: function component() {
    return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 343));
  },
  name: 'page'
}, {
  path: '/album/:id',
  component: function component() {
    return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 327));
  },
  name: 'album'
}, {
  path: '/yunnan',
  component: function component() {
    return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 334));
  },
  name: 'yunnan'
}, {
  path: '/neimeng',
  component: function component() {
    return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 333));
  },
  name: 'neimeng'
}, {
  path: '/agnecycity',
  component: function component() {
    return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 390));
  },
  name: 'agencyCity'
}, {
  path: '/discounts',
  component: function component() {
    return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 394));
  },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 124));
    },
    name: 'discounts_detail'
  }, {
    path: 'detail',
    component: function component() {
      return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 124));
    },
    name: 'discounts_detail'
  }, {
    path: ':id/get',
    component: function component() {
      return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 393));
    },
    name: 'discounts_get'
  }]
}]);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/user',
  component: function component() {
    return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 372));
  },
  meta: { requireAuth: true },
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 355));
    },
    name: 'user'
  }, {
    path: 'saleUser',
    component: function component() {
      return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 377));
    },
    name: 'sale_user'
  }, {
    path: 'order',
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 358));
    },
    name: 'user_order'
  }, {
    path: 'discounts',
    component: function component() {
      return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 364));
    },
    name: 'user_discounts'
  }, {
    path: 'message',
    component: function component() {
      return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 356));
    },
    name: 'user_message'
  }, {
    path: 'messages',
    component: function component() {
      return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 357));
    },
    children: [{
      path: 'comments',
      component: function component() {
        return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 373));
      },
      name: 'messages_comments'
    }, {
      path: 'thumb',
      component: function component() {
        return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 375));
      },
      name: 'messages_thumb'
    }, {
      path: 'notice',
      component: function component() {
        return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 374));
      },
      name: 'messages_notice'
    }]
  }, {
    path: 'feed',
    component: function component() {
      return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 370));
    },
    name: 'user_feed'
  }, {
    path: 'fans',
    component: function component() {
      return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 366));
    },
    name: 'user_fans'
  }, {
    path: 'follow',
    component: function component() {
      return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 371));
    },
    name: 'user_follow'
  }, {
    path: 'faq',
    component: function component() {
      return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 369));
    },
    name: 'user_faq'
  }, {
    path: 'faq_answer',
    component: function component() {
      return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 367));
    },
    name: 'user_faq_answer'
  }, {
    path: 'faq_follow',
    component: function component() {
      return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 368));
    },
    name: 'user_faq_follow'
  }, {
    path: 'setting',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 359));
    },
    name: 'user_setting'
  }, {
    path: 'setting/password',
    component: function component() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 376));
    },
    name: 'setting_password'
  }, {
    path: 'setting/bind-tel',
    component: function component() {
      return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 361));
    },
    name: 'bind_tel'
  }, {
    path: 'setting/edit-tel',
    component: function component() {
      return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 365));
    },
    name: 'edit_tel'
  }, {
    path: 'setting/car-certify',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 363));
    },
    name: 'car_certify'
  }, {
    path: 'camp',
    component: function component() {
      return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 362));
    },
    name: 'user_camp'
  }]
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    default: {
      name: 'default',
      list: [],
      page: 0,
      more: true,
      refresh: true,
      position: 0
    },
    recent: {
      list: [],
      page: 0,
      more: true,
      refresh: true
    },
    hot: {
      list: [],
      page: 0,
      more: true,
      refresh: true
    },
    follow: {
      name: 'follow',
      list: [],
      page: 0,
      more: true,
      refresh: true
    },
    nearby: {
      list: [],
      page: 0,
      more: true,
      refresh: true
    },
    topic: {
      list: [],
      page: 0,
      more: true,
      refresh: true,
      meta: {
        tid: 0
      }
    }
  },
  mutations: {
    saveFeed: function saveFeed(state, _ref) {
      var _ref$page = _ref.page,
          page = _ref$page === undefined ? 1 : _ref$page,
          _ref$list = _ref.list,
          list = _ref$list === undefined ? [] : _ref$list,
          _ref$type = _ref.type,
          type = _ref$type === undefined ? 'default' : _ref$type,
          refresh = _ref.refresh,
          more = _ref.more,
          meta = _ref.meta;

      state[type].page = page || 0;
      state[type].list = list || [];
      if (typeof refresh !== 'undefined') state[type].refresh = refresh;
      if (typeof more !== 'undefined') state[type].more = more;
      if (typeof meta !== 'undefined') state[type].meta = meta;
      console.log('saved', state[type]);
    }
  },
  actions: {
    saveFeed: function saveFeed(_ref2, payload) {
      var commit = _ref2.commit,
          state = _ref2.state;

      commit('saveFeed', payload);
    }
  },
  getters: {
    feedStorage: function feedStorage(state) {
      return function () {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

        return state[type];
      };
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SAVE_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_CURRENT_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_CITY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_CITY_PICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_FEED_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_NAVIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_IS_APP; });


var CLEAR_TOKEN = 'CLEAR_TOKEN';

var SAVE_TOKEN = 'SAVE_TOKEN';

var SAVE_CURRENT_CITY = 'SAVE_CURRENT_CITY';

var SAVE_CITY_LIST = 'SAVE_CITY_LIST';

var SAVE_QUERY = 'SAVE_QUERY';

var SAVE_CITY_PICK = 'SAVE_CITY_PICK';

var SAVE_FEED_LIST = 'SAVE_FEED_LIST';

var SAVE_NAVIGATION = 'SAVE_NAVIGATION';

var SET_IS_APP = 'SET_IS_APP';

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {



var Format = __webpack_require__(56);

module.exports = function () {
  var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var data = [];

  while (from < to) {
    data.push(monthDate(from));
    from++;
  }
  return data;
};

var monthDate = function monthDate() {
  var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var fmt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YYYY-MM-DD';

  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth() + from;

  var firstDayOfMonth = new Date(year, month, 1).getDay();
  var lastDayOfMonth = new Date(year, month + to, 0).getDay();

  var startDateOfMonth = new Date(year, month, 1).getTime();
  var endDateOfMonth = new Date(year, month + to, 0).getTime();

  var startDateTime = startDateOfMonth - firstDayOfMonth * 24 * 60 * 60 * 1000;
  var endDateTime = endDateOfMonth + (6 - lastDayOfMonth) * 24 * 60 * 60 * 1000;

  var rs = [];

  while (startDateTime <= endDateTime) {
    var date = new Date(startDateTime);
    rs.push({
      month: date.getMonth() + 1,
      date: date.getDate(),
      value: Format(startDateTime, fmt),
      isOtherMonth: startDateTime < startDateOfMonth || startDateTime > endDateOfMonth,
      isPrevious: startDateTime + 24 * 60 * 60 * 1000 < now.getTime(),
      isWeekend: date.getDay() === 0 || date.getDay() === 6,
      isActive: false
    });
    startDateTime += 24 * 60 * 60 * 1000;
  }
  return {
    year: new Date(startDateOfMonth).getFullYear(),
    month: new Date(startDateOfMonth).getMonth(),
    isOtherYear: new Date(startDateOfMonth).getFullYear() !== year,
    dates: rs
  };
};

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export payload */
/* unused harmony export valid */


var payload = function payload(token) {
  if (valid(token)) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    var pl = JSON.parse(window.atob(base64));
    var now = new Date().getTime();
    return pl.exp !== undefined && parseInt(pl.exp) > now / 1000 ? pl : false;
  } else {
    return false;
  }
};

var valid = function valid(token) {
  return token !== undefined && token !== null && token.split('.').length === 3;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  payload: payload,
  valid: valid
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(84);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



window.videojs = __webpack_require__(85);
videojs = videojs.default || videojs;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    },
    start: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    playsinline: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    customEventName: {
      type: String,
      default: function _default() {
        return 'statechanged';
      }
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },
  methods: {
    initialize: function initialize() {
      var self = this;
      this.player = null;

      var videoOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5'],
        plugins: {}
      }, this.options);

      var playsinline = this.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(self.customEventName, values);
        }
      };

      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }

      this.player = videojs(this.$el.children[0], videoOptions, function () {
        var _this = this;
        self.$emit('ready', self.player);

        var events = ['loadeddata', 'canplay', 'canplaythrough', 'play', 'pause', 'waiting', 'playing', 'ended', 'error'];
        for (var i = 0; i < events.length; i++) {
          (function (event) {
            _this.on(event, function () {
              emitPlayerState(event, true);
            });
          })(events[i]);
        }

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        if (this.player.techName_ !== 'Flash') {
          this.player.pause && this.player.pause();
        }
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_dom__ = __webpack_require__(108);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new __WEBPACK_IMPORTED_MODULE_1__popup__["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;

      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && __WEBPACK_IMPORTED_MODULE_2__libs_dom__["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && __WEBPACK_IMPORTED_MODULE_2__libs_dom__["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_device__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    getQuery: __WEBPACK_IMPORTED_MODULE_5__tools_util__["a" /* getQuery */]
  },
  mounted: function mounted() {
    var _this = this;

    window['getToken'] = function (res) {
      if (res && res !== 'null') {
        _this.saveToken({ token: res });
      } else {
        _this.doLogout();
      }
    };
  },
  data: function data() {
    return {
      homeShow: false,
      data: null,
      inds: 2
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    isLoggedin: 'isLoggedin',
    querys: 'query',
    is_app: 'is_app'
  })),
  created: function created() {
    this.getAppToken();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(['saveToken', 'doLogout']), {
    getAppToken: function getAppToken() {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var webBean = {
        success: 'getToken',
        fail: null,
        params: null
      };
      var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(webBean);
      if (isiOS) {
        try {
          window.webkit.messageHandlers.getUserToken.postMessage(webBean);
        } catch (err) {}
      } else {
        try {
          window.wfc.getUserToken(str);
        } catch (err) {}
      }
    },
    initCurrentUrl: function initCurrentUrl() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tools_device__["a" /* isWechat */])() && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tools_device__["b" /* isIOS */])()) window.sessionStorage.setItem('initUrl', window.location.href);
      var url = window.sessionStorage.getItem('initUrl') || window.location.href;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].rv.wxcode, { url: url }).then(function (response) {
        if (response.data.code === 200) {
          __WEBPACK_IMPORTED_MODULE_6_weixin_js_sdk___default.a.config({
            debug: false,
            appId: response.data.data.appid,
            timestamp: response.data.data.timestamp,
            nonceStr: response.data.data.noncestr,
            signature: response.data.data.signature,
            jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline']
          });
        }
      });
    },
    initWechatLogin: function initWechatLogin() {
      var _this2 = this;

      var ua = window.navigator.userAgent.toLowerCase();
      if (!this.isLoggedin) {
        if (ua.indexOf('micromessenger') > 0) {
          var url = window.location.href;
          if (url.indexOf('code=') > 0) {
            this.axios.post(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].user.wechatLogin, { code: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tools_util__["a" /* getQuery */])(url, 'code') }).then(function (response) {
              _this2.saveToken({ token: response.headers.authorization });
            });
          } else if (url.indexOf('code=') < 0) {
            var urls = window.location.href;

            urls = encodeURIComponent(urls);
            var t = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf2d2ebedafd76a1b&redirect_uri=' + urls + '&response_type=code&scope=snsapi_userinfo&connect_redirect=1&#wechat_redirect';
            window.location.href = t;
          }
        }
      }
    }
  })
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    play: {
      video: '',
      videoid: ''
    }
  },
  data: function data() {
    return {
      data: null,
      playid: ''
    };
  },

  mounted: function mounted() {},
  methods: {
    players: function players() {
      var player = new Aliplayer({
        id: this.playid,
        source: this.play.video,
        cover: 'https://img01.wanfangche.com/public/video/201804/2018042401.jpg',
        vid: this.play.videoid,
        preload: true,
        controlBarVisibility: 'click',
        accessKeyId: this.data.AccessKeyId,
        accessKeySecret: this.data.AccessKeySecret,
        securityToken: this.data.SecurityToken,
        autoplay: true,
        useH5Prism: true,
        showBuffer: true,
        playsinline: false,
        skinLayout: [{
          "name": "bigPlayButton",
          "align": "cc"
        }, {
          "align": "blabs",
          "x": 0,
          "y": 0,
          "name": "controlBar",
          "children": [{
            "align": "tl",
            "x": 15,
            "y": 26,
            "name": "playButton"
          }, {
            "align": "tl",
            "x": 10,
            "y": 24,
            "name": "timeDisplay"
          }, {
            "align": "tr",
            "x": 20,
            "y": 25,
            "name": "fullScreenButton"
          }, {
            "align": "tr",
            "x": 20,
            "y": 25,
            "name": "volume"
          }, {
            "name": "progress",
            "align": "tlabs",
            "x": 0,
            "y": 0
          }]
        }]
      }, function (ply) {});

      var _video = document.querySelector('video');
      player.on('play', function (e) {
        e.preventDefault = true;
        e.stop;
        _video.removeEventListener('click', play);
        _video.addEventListener('click', pause);
      });
      player.on('pause', function (e) {
        e.preventDefault = true;
        e.stop;
        _video.removeEventListener('click', pause);
        _video.addEventListener('click', play);
      });
      function play() {
        if (player) player.play();
      }
      function pause() {
        if (player) player.pause();
      }
    },
    btn: function btn() {},
    autoPlay: function autoPlay() {
      var url = window.sessionStorage.getItem('initUrl') || window.location.href;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].rv.wxcode, { url: url }).then(function (response) {
        if (response.data.code === 200) {
          __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.config({
            debug: false,
            appId: response.data.data.appid,
            timestamp: 1,
            nonceStr: '',
            signature: '',
            jsApiList: []
          });
          __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.ready(function () {
            var div = document.getElementById(this.playid);
            var video = div.getElementsByTagName('video')[0];
            video.play();
          });
        }
      });
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.play) {
      this.playid = 'playid' + this.play.id;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].feed.videosdk).then(function (response) {
        if (response.data.code === 200) {
          _this2.data = response.data.data.Credentials;
          _this2.players();
          var _this = _this2;
          setTimeout(function () {
            _this.autoPlay();
          }, 500);
        }
      });
    }
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_calendar__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_date_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tools_date_calendar__);





var query = {
  startDate: null,
  endDate: null,
  startTime: null,
  endTime: null
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      list: __WEBPACK_IMPORTED_MODULE_1__tools_date_calendar___default()(0, 6),
      query: query,
      secondTime: false
    };
  },
  created: function created() {
    this.initCalendar();
  },

  methods: {
    initCalendar: function initCalendar() {},
    onDateClick: function onDateClick(item) {
      if (!this.query.startDate || this.query.startDate >= item.value) {
        this.clear();
        this.query.startDate = item.value;
      } else if (!this.secondTime) {
        this.secondTime = true;
        this.query.endDate = item.value;
      } else {
        this.secondTime = false;
        this.clear();
        this.query.startDate = item.value;
      }
      this.resetActive();
    },
    resetActive: function resetActive() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var m = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(m.dates), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              if (item.value >= this.query.startDate && item.value <= this.query.endDate) {
                item.isActive = true;
              } else if (item.value === this.query.startDate) {
                item.isActive = true;
              } else {
                item.isActive = false;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    clear: function clear() {
      this.secondTime = false;
      this.query = {
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null
      };
    },
    reset: function reset() {
      this.clear();
      this.resetActive();
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SecurityCode',

  props: {
    number: {
      type: Number,
      default: 4
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      value: '',
      isShow: false
    };
  },

  methods: {
    hideKeyboard: function hideKeyboard() {
      document.activeElement.blur();
      this.$refs.input.blur();
    },
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.isShow = false;
      if (this.value.length === 4) {
        this.axios.get(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].camp.code, { params: { coding: this.value } }).then(function (response) {
          if (response.data.code === 1) {
            _this.$router.push({
              name: 'camp_detail',
              params: {
                id: response.data.data.uuid
              }
            });
          } else {
            _this.isShow = true;
          }
        });
      }
    },
    handleInput: function handleInput(e) {
      this.$refs.input.value = this.value;
      if (this.value.length >= this.number) {
        this.hideKeyboard();
      }
      this.handleSubmit();
    },
    hide: function hide() {
      this.$emit('codeBtn', 'false');
      this.value = '';
    }
  },
  mounted: function mounted() {},

  watch: {
    value: function value(val) {
      var newStr = val.replace(/\s/g, '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      this.value = newStr;
    }
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: null
  },
  components: {
    Popup: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue___default.a
  },
  data: function data() {
    return {
      show: false,
      currentValue: {
        city: '',
        cityid: ''
      },
      currentLocation: {
        city: '定位中...',
        cityid: null
      },
      height: null
    };
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    currentCity: 'currentCity',
    list: 'cityList'
  }),
  created: function created() {
    var _this = this;

    this.height = 'height:' + document.documentElement.clientHeight + 'px';
    this.$nextTick(function () {
      _this.getGeoLocation();
      _this.initCityList();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])({
    save2store: 'saveCityList',
    saveCurrentCity: 'saveCurrentCity'
  }), {
    initCityList: function initCityList() {
      if (!this.cityList) {
        this.getCityList();
      }
    },
    getCityList: function getCityList() {
      var _this2 = this;

      this.axios.get(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].city.list).then(function (response) {
        if (response.data.code === 200) {
          var lists = response.data.data.list;
          for (var key in lists) {
            for (var keys in lists[key].citylist) {
              if (lists[key].citylist[keys].is_open === '0') {
                lists[key].citylist[keys] = {};
              }
            }
          }
          _this2.save2store({ list: lists });
        }
      });
    },
    setCurrentCity: function setCurrentCity(city) {
      this.show = false;
      this.saveCurrentCity(city);
    },
    getGeoLocation: function getGeoLocation() {
      var _this3 = this;

      navigator.geolocation.getCurrentPosition(function (position) {
        if (position.coords) {
          _this3.axios.get(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].common.currentLocation, { params: {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            } }).then(function (response) {
            if (response.data.code === 200) {
              _this3.currentLocation = response.data.data;
            }
          });
        }
      }, function (error) {
        _this3.currentLocation = {
          city: '定位失败',
          cityid: null
        };
        return error;
      });
    },
    open: function open() {
      this.show = true;
    },
    close: function close() {
      this.show = false;
    },
    onOpen: function onOpen() {
      console.log('onOpen');
    },
    onClose: function onClose() {
      console.log('onClose');
      this.$emit('on-close', this.currentValue);
    }
  }),
  watch: {
    value: function value(val) {},
    show: function show(val) {
      this[val ? 'onOpen' : 'onClose']();
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _this = this;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: false
  },
  data: function data() {
    return {
      popupShow: _this.value,
      emoji: ['&#x1f44a;', '&#x1f44c;', '&#x1f44d;', '&#x1f44e;', '&#x1f44f;', '&#x270a;', '&#x270c;', '&#x1f60d;', '&#x1f60f;', '&#x1f61d;', '&#x1f62d;', '&#x1f602;', '&#x1f603;', '&#x1f609;', '&#x1f612;', '&#x1f618;', '&#x1f621;', '&#x1f624;', '&#x1f630;', '&#x1f631;', '&#x1f633;', '&#x1f637;', '&#x2764;']
    };
  },
  methods: {
    insertEmoji: function insertEmoji(e) {
      this.$emit('insert', e.target.innerHTML);
    }
  },
  watch: {
    value: function value(val) {
      this.popupShow = val;
    },
    popupShow: function popupShow(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      loading: false
    };
  },

  methods: {
    onChange: function onChange(e) {
      var _this = this;

      if (this.$refs.input.files[0]) {
        this.loading = true;
        this.axios.upload(this.$refs.input.files[0]).then(function (response) {
          _this.loading = false;
          if (response.data.data) {
            _this.currentValue = response.data.data.filename;
          }
        }).catch(function (error) {
          _this.loading = false;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
        });
      }
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: 0
  },
  computed: {
    objClass: function objClass() {
      if (parseInt(this.value) === 1) {
        return 'fd-male male-color';
      } else if (parseInt(this.value) === 2) {
        return 'fd-female female-color';
      } else {
        return;
      }
    }
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    list: null,
    col: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    return {
      imageList: [],
      width: '33.333333%',
      height: 'auto'
    };
  },

  computed: {
    objStyle: function objStyle() {
      return {
        width: this.width + 'px',
        height: this.height + 'px'
      };
    }
  },

  methods: {
    initHeight: function initHeight() {
      this.width = this.$el.clientWidth / this.col;
      this.height = this.width;
    },
    initList: function initList() {
      if (typeof this.list === 'string') {
        this.imageList = this.list.split(',');
      } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.list) === 'object') {
        this.imageList = this.list;
      } else {}
    },
    albumView: function albumView(src, list) {
      if (window.WeixinJSBridge) {
        window.WeixinJSBridge.invoke('imagePreview', {
          'urls': list.map(function (src) {
            return src + '?x-oss-process=style/large';
          }),
          'current': src + '?x-oss-process=style/large'
        });
      }
    }
  },

  mounted: function mounted() {
    this.initHeight();
    this.initList();
  },

  watch: {
    col: function col(val) {
      this.initHeight();
    },
    list: function list(val) {
      this.initList();
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-modal',

  props: {
    title: {
      type: String,
      default: 'UiModal title'
    },
    size: {
      type: String,
      default: 'normal' },
    role: {
      type: String,
      default: 'dialog' },
    transition: {
      type: String,
      default: 'scale' },
    removeHeader: {
      type: Boolean,
      default: false
    },
    removeCloseButton: {
      type: Boolean,
      default: false
    },
    preventShift: {
      type: Boolean,
      default: false
    },
    dismissible: {
      type: Boolean,
      default: true
    },
    dismissOn: {
      type: String,
      default: 'backdrop esc close-button'
    }
  },

  data: function data() {
    return {
      isOpen: false,
      lastfocusedElement: null
    };
  },


  computed: {
    classes: function classes() {
      return ['ui-modal--size-' + this.size, { 'has-footer': this.hasFooter }, { 'is-open': this.isOpen }];
    },
    hasFooter: function hasFooter() {
      return Boolean(this.$slots.footer);
    },
    toggleTransition: function toggleTransition() {
      return 'ui-modal--transition-' + this.transition;
    },
    dismissOnBackdrop: function dismissOnBackdrop() {
      return this.dismissOn.indexOf('backdrop') > -1;
    },
    dismissOnCloseButton: function dismissOnCloseButton() {
      return this.dismissOn.indexOf('close-button') > -1;
    },
    dismissOnEsc: function dismissOnEsc() {
      return this.dismissOn.indexOf('esc') > -1;
    }
  },

  watch: {
    isOpen: function isOpen() {
      var _this = this;

      this.$nextTick(function () {
        _this[_this.isOpen ? 'onOpen' : 'onClose']();
      });
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (this.isOpen) {
      this.teardownModal();
    }
  },


  methods: {
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false;
    },
    closeModal: function closeModal(e) {
      if (!this.dismissible) {
        return;
      }

      if (e.currentTarget === this.$refs.backdrop && e.target !== e.currentTarget) {
        return;
      }

      this.isOpen = false;
    },
    onOpen: function onOpen() {
      this.lastfocusedElement = document.activeElement;
      this.$refs.container.focus();

      document.addEventListener('focus', this.restrictFocus, true);

      this.$emit('open');
    },
    onClose: function onClose() {
      this.teardownModal();
      this.$emit('close');
    },
    redirectFocus: function redirectFocus() {
      this.$refs.container.focus();
    },
    restrictFocus: function restrictFocus(e) {
      if (!this.$refs.container.contains(e.target)) {
        e.stopPropagation();
        this.$refs.container.focus();
      }
    },
    teardownModal: function teardownModal() {
      document.removeEventListener('focus', this.restrictFocus, true);

      if (this.lastfocusedElement) {
        this.lastfocusedElement.focus();
      }
    },
    onEnter: function onEnter() {
      this.$emit('reveal');
    },
    onLeave: function onLeave() {
      this.$emit('hide');
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var parsePlain = function parsePlain(str, len) {
  var rel = str ? str.replace(/<[^<>]+?>/g, '') : '';
  return len && rel && rel.length > len ? rel.substring(0, len) + '...' : rel;
};

var parseSimple = function parseSimple(str, len) {
  return str ? str.replace(/\r/g, '&nbsp;').replace(/\n/g, '<br />') : '';
};

var parseHTML = function parseHTML(str, len) {
  return str;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    enter: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'plain'
    },
    length: {
      type: Number
    },
    value: null
  },
  computed: {
    currentValue: function currentValue() {
      switch (this.type) {
        case 'plain':
          return parsePlain(this.value, this.length);
        case 'html':
          return parseHTML(this.value, this.length);
        case 'simple':
          return parseSimple(this.value, this.length);
        default:
          return parsePlain(this.value, this.length);
      }
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_upload__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__file_upload__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_0__file_upload___default.a
  },
  data: function data() {
    return {
      files: [],
      headers: {},
      data: {},
      postAction: '/server/community/public/common/upload',
      extensions: 'gif,jpg,jpeg,png,webp',
      accept: 'image/*',
      multiple: true,
      drop: false,
      dropDirectory: false,
      size: 1024 * 1024 * 10,
      thread: 9,
      automatic: true,
      maxLength: 9,
      preload: true
    };
  },
  methods: {
    previewImage: function previewImage(file) {
      if (window.WeixinJSBridge) {
        window.WeixinJSBridge.invoke('imagePreview', {
          'urls': this.files.map(function (file) {
            return file.response.data ? file.response.data[0].filename + '_large' : undefined;
          }),
          'current': file.response.data ? file.response.data[0].filename + '_large' : false
        });
      }
    },
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.blob = '';
        var URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }

        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }
      }
    },
    inputFile: function inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {}
      if (newFile && oldFile) {

        if (newFile.active && !oldFile.active) {
          if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
            this.$refs.upload.update(newFile, { error: 'size' });
          }
        }

        if (newFile.progress !== oldFile.progress) {}

        if (newFile.error && !oldFile.error) {}

        if (newFile.success && !oldFile.success) {
          this.emitInput();
        }

        if (newFile.success !== oldFile.success) {}
      }

      if (!newFile && oldFile) {
        this.emitInput();
      }

      if (this.automatic) {
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (!this.$refs.upload.active) {
            this.$refs.upload.active = true;
          }
        }
      }
    },
    emitInput: function emitInput() {
      var rel = [];
      rel = this.files.map(function (file) {
        return file.response.data ? file.response.data[0].filename : undefined;
      });
      this.$emit('input', rel);
    },
    clear: function clear() {
      this.$refs.upload.clear();
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__input_file_vue__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__input_file_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__input_file_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    InputFile: __WEBPACK_IMPORTED_MODULE_5__input_file_vue___default.a
  },
  props: {
    inputId: {
      type: String
    },

    name: {
      type: String,
      default: 'file'
    },

    accept: {
      type: String
    },

    capture: {
      type: String
    },

    preload: {
      type: Boolean
    },

    multiple: {
      type: Boolean
    },

    addIndex: {
      type: [Boolean, Number]
    },

    directory: {
      type: Boolean
    },

    postAction: {
      type: String
    },

    putAction: {
      type: String
    },

    headers: {
      type: Object,
      default: Object
    },

    data: {
      type: Object,
      default: Object
    },

    timeout: {
      type: Number,
      default: 0
    },

    drop: {
      default: false
    },

    dropDirectory: {
      type: Boolean,
      default: true
    },

    size: {
      type: Number,
      default: 0
    },

    extensions: {
      default: Array
    },

    value: {
      type: Array,
      default: Array
    },

    thread: {
      type: Number,
      default: 1
    },

    maxLength: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      files: this.value,
      features: {
        html5: true,
        directory: false,
        drag: false
      },

      active: false,
      dropActive: false,

      uploading: 0,

      destroy: false
    };
  },
  mounted: function mounted() {
    var input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;

    if (window.FormData && input.files) {
      if (typeof input.webkitdirectory === 'boolean' || typeof input.directory === 'boolean') {
        this.features.directory = true;
      }

      if (this.features.html5 && typeof input.ondrop !== 'undefined') {
        this.features.drop = true;
      }
    } else {
      this.features.html5 = false;
    }

    this.maps = {};

    this.$nextTick(function () {
      if (this.$parent) {
        this.$parent.$forceUpdate();
      }

      this.watchDrop(this.drop);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy = true;

    this.active = false;
  },


  computed: {
    uploaded: function uploaded() {
      var file = void 0;
      for (var i = 0; i < this.files.length; i++) {
        file = this.files[i];
        if (file.fileObject && !file.error && !file.success) {
          return false;
        }
      }
      return true;
    },
    className: function className() {
      return ['file-uploads', this.features.html5 ? 'file-uploads-html5' : 'file-uploads-html4', this.features.directory && this.directory ? 'file-uploads-directory' : undefined, this.features.drop && this.drop ? 'file-uploads-drop' : undefined];
    }
  },

  watch: {
    active: function active(_active) {
      this.watchActive(_active);
    },
    dropActive: function dropActive() {
      if (this.$parent) {
        this.$parent.$forceUpdate();
      }
    },
    drop: function drop(value) {
      this.watchDrop(value);
    },
    value: function value(files) {
      if (this.files === files) {
        return;
      }
      this.files = files;

      var oldMaps = this.maps;

      this.maps = {};
      for (var i = 0; i < this.files.length; i++) {
        var file = this.files[i];
        this.maps[file.id] = file;
      }

      for (var key in this.maps) {
        var newFile = this.maps[key];
        var oldFile = oldMaps[key];
        if (newFile !== oldFile) {
          this.emitFile(newFile, oldFile);
        }
      }

      for (var _key in oldMaps) {
        if (!this.maps[_key]) {
          this.emitFile(undefined, oldMaps[_key]);
        }
      }
    }
  },

  methods: {
    clear: function clear() {
      if (this.files.length) {
        var files = this.files;
        this.files = [];

        this.maps = {};

        this.emitInput();
        for (var i = 0; i < files.length; i++) {
          this.emitFile(undefined, files[i]);
        }
      }
      return true;
    },
    get: function get(id) {
      if (!id) {
        return false;
      }

      if ((typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(id)) === 'object') {
        return this.maps[id.id] || false;
      }

      return this.maps[id] || false;
    },
    add: function add(_files) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.addIndex;

      var files = _files;
      var isArray = files instanceof Array;

      if (!isArray) {
        files = [files];
      }

      var addFiles = [];
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        if (this.features.html5 && file instanceof Blob) {
          file = {
            width: 100,
            heigth: 100,
            file: file,
            size: file.size,
            name: file.webkitRelativePath || file.relativePath || file.name || 'unknown',
            type: file.type
          };
        }
        var fileObject = false;
        if (file.fileObject === false) {} else if (file.fileObject) {
          fileObject = true;
        } else if (typeof Element !== 'undefined' && file.el instanceof Element) {
          fileObject = true;
        } else if (typeof Blob !== 'undefined' && file.file instanceof Blob) {
          fileObject = true;
        }
        if (fileObject) {
          file = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
            fileObject: true,
            size: -1,
            name: 'Filename',
            type: '',
            active: false,
            error: '',
            success: false,
            putAction: this.putAction,
            postAction: this.postAction,
            timeout: this.timeout
          }, file, {
            response: {},

            progress: '0.00',
            speed: 0 });

          file.data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.data, file.data ? file.data : {});

          file.headers = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.headers, file.headers ? file.headers : {});
        }

        if (!file.id) {
          file.id = Math.random().toString(36).substr(2);
        }

        if (this.emitFilter(file, undefined)) {
          continue;
        }
        addFiles.push(file);

        if (!this.multiple) {
          break;
        }
      }

      if (!addFiles.length) {
        return false;
      }

      if (!this.multiple) {
        this.clear();
      }

      var newFiles = void 0;
      if (index === true || index === 0) {
        newFiles = addFiles.concat(this.files);
      } else if (index) {
        newFiles = addFiles.concat([]);
        newFiles.splice(index, 0, addFiles);
      } else {
        newFiles = this.files.concat(addFiles);
      }

      this.files = newFiles;

      for (var _i = 0; _i < addFiles.length; _i++) {
        var _file2 = addFiles[_i];
        this.maps[_file2.id] = _file2;
      }

      this.emitInput();
      for (var _i2 = 0; _i2 < addFiles.length; _i2++) {
        this.emitFile(addFiles[_i2], undefined);
      }

      return isArray ? addFiles : addFiles[0];
    },
    addInputFileWithPreload: function addInputFileWithPreload(el) {
      var _this2 = this;

      var files = [];
      var count = 0;
      var _this = this;

      if (el.files) {
        var reader;

        (function () {
          var applyLength = _this2.maxLength > 0 ? _this2.maxLength - _this2.files.length : el.files.length;
          var newLength = applyLength > el.files.length ? el.files.length : applyLength;

          var _loop = function _loop(i) {
            var file = el.files[i];
            reader = new FileReader();

            reader.onload = function (e) {
              var data = e.target.result;
              var image = new Image();
              image.onload = function () {
                files.push({
                  width: image.width,
                  height: image.height,
                  size: file.size,
                  name: file.webkitRelativePath || file.relativePath || file.name,
                  type: file.type,
                  file: file,
                  el: el
                });
                count++;
                if (count >= newLength) return _this.add(files);
              };
              image.src = data;
            };
            reader.readAsDataURL(file);
          };

          for (var i = 0; i < newLength; i++) {
            _loop(i);
          }
        })();
      } else {
        files.push({
          name: el.value.replace(/^.*?([^\/\\\r\n]+)$/, '$1'),
          el: el
        });
      }
    },
    addInputFile: function addInputFile(el) {
      var files = [];
      if (el.files) {

        var applyLength = this.maxLength > 0 ? this.maxLength - this.files.length : el.files.length;
        var newLength = applyLength > el.files.length ? el.files.length : applyLength;

        for (var i = 0; i < newLength; i++) {
          var _file3 = el.files[i];
          files.push({
            size: _file3.size,
            name: _file3.webkitRelativePath || _file3.relativePath || _file3.name,
            type: _file3.type,
            file: _file3,
            el: el
          });
        }
      } else {
        files.push({
          name: el.value.replace(/^.*?([^\/\\\r\n]+)$/, '$1'),
          el: el
        });
      }
      return this.add(files);
    },
    addDataTransfer: function addDataTransfer(dataTransfer) {
      var _this3 = this;

      var files = [];
      if (dataTransfer.items && dataTransfer.items.length) {
        var items = [];
        for (var i = 0; i < dataTransfer.items.length; i++) {
          var item = dataTransfer.items[i];
          if (item.getAsEntry) {
            item = item.getAsEntry();
          } else if (item.webkitGetAsEntry) {
            item = item.webkitGetAsEntry();
          } else {
            item = item.getAsFile();
          }
          if (item) {
            items.push(item);
          }
        }

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var forEach = function forEach(i) {
            var item = items[i];

            if (!item || !_this3.multiple && files.length) {
              return resolve(_this3.add(files));
            }
            _this3.getEntry(item).then(function (results) {
              files.push.apply(files, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(results));
              forEach(i + 1);
            });
          };
          forEach(0);
        });
      }

      if (dataTransfer.files.length) {
        for (var _i3 = 0; _i3 < dataTransfer.files.length; _i3++) {
          files.push(dataTransfer.files[_i3]);
          if (!this.multiple) {
            break;
          }
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(this.add(files));
      }

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve([]);
    },
    getEntry: function getEntry(entry) {
      var _this4 = this;

      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (entry.isFile) {
          entry.file(function (file) {
            resolve([{
              size: file.size,
              name: path + file.name,
              type: file.type,
              file: file
            }]);
          });
        } else if (entry.isDirectory && _this4.dropDirectory) {
          entry.createReader().readEntries(function (entries) {
            var files = [];
            var forEach = function forEach(i) {
              if (!entries[i] || files.length && !_this4.multiple) {
                return resolve(files);
              }
              _this4.getEntry(entries[i], path + entry.name + '/').then(function (results) {
                files.push.apply(files, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(results));
                forEach(i + 1);
              });
            };
            forEach(0);
          });
        } else {
          resolve([]);
        }
      });
    },
    replace: function replace(id1, id2) {
      var file1 = this.get(id1);
      var file2 = this.get(id2);
      if (!file1 || !file2 || file1 === file2) {
        return false;
      }
      var files = this.files.concat([]);
      var index1 = files.indexOf(file1);
      var index2 = files.indexOf(file2);
      if (index1 === -1 || index2 === -1) {
        return false;
      }
      files[index1] = file2;
      files[index2] = file1;
      this.files = files;
      this.emitInput();
      return true;
    },
    remove: function remove(id) {
      var file = this.get(id);
      if (file) {
        if (this.emitFilter(undefined, file)) {
          return false;
        }
        var files = this.files.concat([]);
        var index = files.indexOf(file);
        if (index === -1) {
          return false;
        }
        files.splice(index, 1);
        this.files = files;

        delete this.maps[file.id];

        this.emitInput();
        this.emitFile(undefined, file);
      }
      return file;
    },
    update: function update(id, data) {
      var file = this.get(id);
      if (file) {
        var newFile = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, file, data);

        if (file.fileObject && file.active && !newFile.active && !newFile.error && !newFile.success) {
          newFile.error = 'abort';
        }

        if (this.emitFilter(newFile, file)) {
          return false;
        }

        var files = this.files.concat([]);
        var index = files.indexOf(file);
        if (index === -1) {
          console.error('update', file);
          return false;
        }
        files.splice(index, 1, newFile);
        this.files = files;

        delete this.maps[file.id];
        this.maps[newFile.id] = newFile;

        this.emitInput();
        this.emitFile(newFile, file);
        return newFile;
      }
      return false;
    },
    emitFilter: function emitFilter(newFile, oldFile) {
      var isPrevent = false;
      this.$emit('input-filter', newFile, oldFile, function () {
        isPrevent = true;
        return isPrevent;
      });
      return isPrevent;
    },
    emitFile: function emitFile(newFile, oldFile) {
      this.$emit('input-file', newFile, oldFile);
      if (newFile && newFile.fileObject && newFile.active && (!oldFile || !oldFile.active)) {
        this.uploading++;

        this.$nextTick(function () {
          var _this5 = this;

          setTimeout(function () {
            _this5.upload(newFile).then(function () {
              newFile = _this5.get(newFile);
              if (newFile && newFile.fileObject) {
                _this5.update(newFile, {
                  active: false,
                  success: !newFile.error
                });
              }
            }).catch(function (e) {
              _this5.update(newFile, {
                active: false,
                success: false,
                error: e.code || e.error || e.message || e
              });
            });
          }, parseInt(Math.random() * 50 + 50, 10));
        });
      } else if ((!newFile || !newFile.fileObject || !newFile.active) && oldFile && oldFile.fileObject && oldFile.active) {
        this.uploading--;
      }

      if (this.active && (Boolean(newFile) !== Boolean(oldFile) || newFile.active !== oldFile.active)) {
        this.watchActive(true);
      }
    },
    emitInput: function emitInput() {
      this.$emit('input', this.files);
    },
    upload: function upload(id) {
      var file = this.get(id);

      if (!file) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject('not_exists');
      }

      if (!file.fileObject) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject('file_object');
      }

      if (file.error) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(file.error);
      }

      if (file.success) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(file);
      }

      var extensions = this.extensions;
      if (extensions && (extensions.length || typeof extensions.length === 'undefined')) {
        if ((typeof extensions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(extensions)) !== 'object' || !(extensions instanceof RegExp)) {
          if (typeof extensions === 'string') {
            extensions = extensions.split(',').map(function (value) {
              return value.trim();
            }).filter(function (value) {
              return value;
            });
          }
          extensions = new RegExp('\\.(' + extensions.join('|').replace(/\./g, '\\.') + ')$', 'i');
        }
        if (file.name.search(extensions) === -1) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject('extension');
        }
      }

      if (this.size > 0 && file.size >= 0 && file.size > this.size) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject('size');
      }

      if (this.features.html5 && file.putAction) {
        return this.uploadPut(file);
      } else if (this.features.html5) {
        return this.uploadHtml5(file);
      } else {
        return this.uploadHtml4(file);
      }
    },
    uploadPut: function uploadPut(file) {
      var querys = [];
      var value = void 0;
      for (var key in file.data) {
        value = file.data[key];
        if (value !== null && value !== undefined) {
          querys.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
      }
      var queryString = querys.length ? (file.putAction.indexOf('?') === -1 ? '?' : '&') + querys.join('&') : '';
      var xhr = new XMLHttpRequest();
      xhr.open('PUT', file.putAction + queryString);
      return this.uploadXhr(xhr, file, file.file);
    },
    uploadHtml5: function uploadHtml5(file) {
      var form = new window.FormData();
      var value = void 0;
      for (var key in file.data) {
        value = file.data[key];
        if (value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(value)) === 'object' && typeof value.toString !== 'function') {
          if (value instanceof File) {
            form.append(key, value, value.name);
          } else {
            form.append(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
          }
        } else if (value !== null && value !== undefined) {
          form.append(key, value);
        }
      }
      form.append(this.name, file.file, file.file.filename || file.name);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', file.postAction);
      return this.uploadXhr(xhr, file, form);
    },
    uploadXhr: function uploadXhr(xhr, _file, body) {
      var _this6 = this;

      var file = _file;
      var speedTime = 0;
      var speedLoaded = 0;

      xhr.upload.onprogress = function (e) {
        file = _this6.get(file);
        if (!e.lengthComputable || !file || !file.fileObject || !file.active) {
          return;
        }

        var speedTime2 = Math.round(Date.now() / 1000);
        if (speedTime2 === speedTime) {
          return;
        }
        speedTime = speedTime2;

        file = _this6.update(file, {
          progress: (e.loaded / e.total * 100).toFixed(2),
          speed: e.loaded - speedLoaded
        });
        speedLoaded = e.loaded;
      };

      var interval = setInterval(function () {
        file = _this6.get(file);
        if (file && file.fileObject && !file.success && !file.error && file.active) {
          return;
        }

        if (interval) {
          clearInterval(interval);
          interval = false;
        }

        try {
          xhr.abort();
          xhr.timeout = 1;
        } catch (e) {}
      }, 100);

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var complete = void 0;
        var fn = function fn(e) {
          if (complete) {
            return;
          }
          complete = true;
          if (interval) {
            clearInterval(interval);
            interval = false;
          }

          file = _this6.get(file);

          if (!file) {
            return reject('not_exists');
          }

          if (!file.fileObject) {
            return reject('file_object');
          }

          if (file.error) {
            return reject(file.error);
          }

          if (!file.active) {
            return reject('abort');
          }

          if (file.success) {
            return resolve(file);
          }

          var data = {};

          switch (e.type) {
            case 'timeout':
            case 'abort':
              data.error = e.type;
              break;
            case 'error':
              if (!xhr.status) {
                data.error = 'network';
              } else if (xhr.status >= 500) {
                data.error = 'server';
              } else if (xhr.status >= 400) {
                data.error = 'denied';
              }
              break;
            default:
              if (xhr.status >= 500) {
                data.error = 'server';
              } else if (xhr.status >= 400) {
                data.error = 'denied';
              } else {
                data.progress = '100.00';
              }
          }

          if (xhr.responseText) {
            var contentType = xhr.getResponseHeader('Content-Type');
            if (contentType && contentType.indexOf('/json') !== -1) {
              data.response = JSON.parse(xhr.responseText);
            } else {
              data.response = xhr.responseText;
            }
          }

          file = _this6.update(file, data);

          if (file.error) {
            return reject(file.error);
          }

          return resolve(file);
        };

        xhr.onload = fn;
        xhr.onerror = fn;
        xhr.onabort = fn;
        xhr.ontimeout = fn;

        if (file.timeout) {
          xhr.timeout = file.timeout;
        }

        for (var key in file.headers) {
          xhr.setRequestHeader(key, file.headers[key]);
        }

        file = _this6.update(file, { xhr: xhr });

        xhr.send(body);
      });
    },
    uploadHtml4: function uploadHtml4(_file) {
      var _this7 = this;

      var file = _file;
      var onKeydown = function onKeydown(e) {
        if (e.keyCode === 27) {
          e.preventDefault();
        }
      };

      var iframe = document.createElement('iframe');
      iframe.id = 'upload-iframe-' + file.id;
      iframe.name = 'upload-iframe-' + file.id;
      iframe.src = 'about:blank';
      iframe.setAttribute('style', 'width:1px;height:1px;top:-999em;position:absolute; margin-top:-999em;');

      var form = document.createElement('form');

      form.action = file.postAction;

      form.name = 'upload-form-' + file.id;

      form.setAttribute('method', 'POST');
      form.setAttribute('target', 'upload-iframe-' + file.id);
      form.setAttribute('enctype', 'multipart/form-data');

      var value = void 0;
      var input = void 0;
      for (var key in file.data) {
        value = file.data[key];
        if (value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(value)) === 'object' && typeof value.toString !== 'function') {
          value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
        }
        if (value !== null && value !== undefined) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          form.appendChild(input);
        }
      }
      form.appendChild(file.el);

      document.body.appendChild(iframe).appendChild(form);

      var getResponseData = function getResponseData() {
        var doc = void 0;
        try {
          if (iframe.contentWindow) {
            doc = iframe.contentWindow.document;
          }
        } catch (err) {}
        if (!doc) {
          try {
            doc = iframe.contentDocument ? iframe.contentDocument : iframe.document;
          } catch (err) {
            doc = iframe.document;
          }
        }
        if (doc && doc.body) {
          return doc.body.innerHTML;
        }
        return null;
      };

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        setTimeout(function () {
          file = _this7.update(file, { iframe: iframe });

          if (!file) {
            return reject('not_exists');
          }

          var interval = setInterval(function () {
            file = _this7.get(file);
            if (file && file.fileObject && !file.success && !file.error && file.active) {
              return;
            }

            if (interval) {
              clearInterval(interval);
              interval = false;
            }

            iframe.onabort({ type: file ? 'abort' : 'not_exists' });
          }, 100);

          var complete = void 0;
          var fn = function fn(e) {
            if (complete) {
              return;
            }
            complete = true;

            if (interval) {
              clearInterval(interval);
              interval = false;
            }

            document.body.removeEventListener('keydown', onKeydown);

            file = _this7.get(file);

            if (!file) {
              return reject('not_exists');
            }

            if (!file.fileObject) {
              return reject('file_object');
            }

            if (file.error) {
              return reject(file.error);
            }

            if (!file.active) {
              return reject('abort');
            }

            if (file.success) {
              return resolve(file);
            }

            var response = getResponseData();
            var data = {};
            switch (e.type) {
              case 'abort':
                data.error = 'abort';
                break;
              case 'error':
                if (file.error) {
                  data.error = file.error;
                } else if (response === null) {
                  data.error = 'network';
                } else {
                  data.error = 'denied';
                }
                break;
              default:
                if (file.error) {
                  data.error = file.error;
                } else if (data === null) {
                  data.error = 'network';
                } else {
                  data.progress = '100.00';
                }
            }

            if (response !== null) {
              if (response && response.substr(0, 1) === '{' && response.substr(response.length - 1, 1) === '}') {
                try {
                  response = JSON.parse(response);
                } catch (err) {}
              }
              data.response = response;
            }

            file = _this7.update(file, data);

            if (file.error) {
              return reject(file.error);
            }

            return resolve(file);
          };

          iframe.onload = fn;
          iframe.onerror = fn;
          iframe.onabort = fn;

          document.body.addEventListener('keydown', onKeydown);

          form.submit();
        }, 50);
      }).then(function (res) {
        iframe.parentNode && iframe.parentNode.removeChild(iframe);
        return res;
      }).catch(function (res) {
        iframe.parentNode && iframe.parentNode.removeChild(iframe);
        return res;
      });
    },
    watchActive: function watchActive(active) {
      var file = void 0;
      var index = 0;
      while (file = this.files[index]) {
        index++;
        if (!file.fileObject) {} else if (active && !this.destroy) {
          if (this.uploading >= this.thread || this.uploading && !this.features.html5) {
            break;
          }
          if (!file.active && !file.error && !file.success) {
            this.update(file, { active: true });
          }
        } else {
          if (file.active) {
            this.update(file, { active: false });
          }
        }
      }
      if (this.uploading === 0) {
        this.active = false;
      }
    },
    watchDrop: function watchDrop(_el) {
      var el = _el;
      if (!this.features.drop) {
        return;
      }

      if (this.dropElement) {
        try {
          document.removeEventListener('dragenter', this.onDragenter, false);
          document.removeEventListener('dragleave', this.onDragleave, false);
          this.dropElement.removeEventListener('dragover', this.onDragover, false);
          this.dropElement.removeEventListener('drop', this.onDrop, false);
        } catch (e) {}
      }

      if (!el) {
        el = false;
      } else if (typeof el === 'string') {
        el = document.querySelector(el) || this.$root.$el.querySelector(el);
      } else if (el === true) {
        el = this.$parent.$el;
      }

      this.dropElement = el;

      if (this.dropElement) {
        document.addEventListener('dragenter', this.onDragenter, false);
        document.addEventListener('dragleave', this.onDragleave, false);
        this.dropElement.addEventListener('dragover', this.onDragover, false);
        this.dropElement.addEventListener('drop', this.onDrop, false);
      }
    },
    onDragenter: function onDragenter(e) {
      e.preventDefault();
      if (!this.dropActive) {
        this.dropActive = true;
      }
    },
    onDragleave: function onDragleave(e) {
      e.preventDefault();
      if (e.target.nodeName === 'HTML' || e.screenX === 0 && e.screenY === 0 && e.screenY === 0 && !e.fromElement && e.offsetX < 0) {
        this.dropActive = false;
      }
    },
    onDragover: function onDragover(e) {
      e.preventDefault();
    },
    change: function change(e) {
      this.preload ? this.addInputFileWithPreload(e.target) : this.addInputFile(e.target);
    },
    onDrop: function onDrop(e) {
      e.preventDefault();
      this.dropActive = false;
      this.addDataTransfer(e.dataTransfer);
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    change: function change(e) {
      this.$destroy();
      this.$parent.preload ? this.$parent.addInputFileWithPreload(e.target) : this.$parent.addInputFile(e.target);
      new this.constructor({
        parent: this.$parent,
        el: this.$el
      });
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__video_player__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__video_player__);




var formatLink = function formatLink(str) {
  if (str) {
    var rel = str.match(/((http|https):\/\/([\w-]+\.)+[\w-]+(\/[\w\u4e00-\u9fa5\-./?@%!&=+~:#;,]*)?)/i);
    return rel ? unescape(rel[0]) : null;
  }
};

var getQuery = function getQuery(link, name) {
  if (link) {
    var reg = new RegExp('(^|)' + name + '=([^&]*)(&|$)');
    var r = link.match(reg);
    if (r !== null) return unescape(r[2]);else return null;
  }
};

var parseQQLink = function parseQQLink(link) {
  if (link) {
    var vid = getQuery(link, 'vid');
    if (!vid) {
      var rel = link.match(/(\/)([0-9a-zA-Z]*)(\.html)/);
      vid = rel ? unescape(rel[2]) : null;
    } else {}
    return vid ? 'https://v.qq.com/iframe/player.html?vid=' + vid + '&auto=0' : null;
  }
};

var parseIqiyi = function parseIqiyi(link) {
  return null;
};

var parseYouku = function parseYouku(link) {
  if (link) {
    if (link.indexOf('/embed/') !== -1) {
      return link;
    } else {
      var rel = link.match(/(\/id_)([0-9a-zA-Z=]*)(\.html)/i);
      return rel ? 'https://player.youku.com/embed/' + unescape(rel[2]) : null;
    }
  } else {
    return null;
  }
};

var getIframeLink = function getIframeLink(link) {
  if (link) {
    if (link.indexOf('v.qq.com') !== -1) {
      return parseQQLink(link);
    } else if (link.indexOf('iqiyi.com') !== -1) {
      return parseIqiyi(link);
    } else if (link.indexOf('youku.com') !== -1) {
      return parseYouku(link);
    } else {
      console.log(link, 22);
      return null;
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    videoPlayer: __WEBPACK_IMPORTED_MODULE_0__video_player___default.a
  },
  props: {
    src: {
      type: String
    },
    allowfullscreen: {
      type: Boolean,
      default: true
    },

    zoom: {
      type: Number,
      default: null
    },
    poster: {
      type: String
    }
  },
  data: function data() {
    return {
      iframeLink: null,
      mp4Link: null,
      height: 212,
      width: 375
    };
  },
  methods: {
    init: function init() {
      this.initHeight();
      this.initPoster();
      this.initSrc();
    },
    initHeight: function initHeight() {
      var ratio = getQuery(this.src, 'wfc_ratio');
      if (ratio) {
        var newRatio = ratio.split(':');
        if (this.zoom && parseInt(newRatio[0]) < parseInt(newRatio[1])) {
          this.width = this.$el.clientWidth * this.zoom / 100;
        } else {
          this.width = this.$el.clientWidth;
        }
        this.height = Math.ceil(this.width * parseInt(newRatio[1]) / parseInt(newRatio[0]));
      } else {
        this.width = this.$el.clientWidth;
        this.height = Math.ceil(this.width * 9 / 16);
      }
    },
    initPoster: function initPoster() {
      var poster = getQuery(this.src, 'wfc_poster');
      if (poster) this.poster = poster;
    },
    initSrc: function initSrc() {
      this.mp4Link = null;
      this.iframeLink = null;
      var link = formatLink(this.src);
      if (link) {
        if (link.indexOf('.mp4') !== -1 || link.indexOf('.webm') !== -1 || link.indexOf('.mov') !== -1 || link.indexOf('wanfangche') !== -1) {
          this.mp4Link = link;
        } else {
          this.iframeLink = getIframeLink(link);
        }
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_video_player__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_video_player__);


__webpack_require__(230);
__webpack_require__(231);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    videoPlayer: __WEBPACK_IMPORTED_MODULE_0_vue_video_player__["videoPlayer"]
  },

  props: {
    src: {
      type: String,
      default: null
    },
    poster: {
      type: String,
      default: ''
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    preload: {
      type: String,
      default: 'auto'
    }
  },

  data: function data() {
    return {
      playerOptions: {}
    };
  },

  computed: {
    player: function player() {
      return this.$refs.videoPlayer.player;
    }
  },

  mounted: function mounted() {
    this.playerOptions = {
      muted: false,
      width: this.width || this.$el.clientWidth,
      height: this.height || Math.ceil(this.$el.clientWidth * 9 / 16),
      language: 'en',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [{
        type: 'video/mp4',
        src: this.src
      }],
      poster: this.poster,
      preload: this.preload
    };
  },

  methods: {
    onPlayerPlay: function onPlayerPlay(player) {},
    onPlayerPause: function onPlayerPause(player) {},
    playerStateChanged: function playerStateChanged(playerCurrentState) {},
    playerReadied: function playerReadied(player) {}
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);





var status = {
  top: 0,
  loading: false,
  error: null,
  infiniting: false,
  isInfinite: true
};
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      options: {
        type: Object,
        default: function _default() {
          return {
            api: null,
            params: {}
          };
        }
      },
      status: status,
      page: 1,
      list: [],
      newList: []
    };
  },

  methods: {
    init: function init(options) {
      var _this = this;

      this.resetData();
      this.options = options;
      return this.getList().then(function (response) {
        _this.$emit('on-load', response);
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(_this.list);
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    resetData: function resetData() {
      this.status = {
        top: 0,
        loading: false,
        error: null,
        infiniting: false,
        isInfinite: true
      };
      this.page = 1;
      this.list = [];
    },
    getList: function getList() {
      var _this2 = this;

      var _options = this.options,
          api = _options.api,
          params = _options.params,
          response = _options.response;

      var responseObject = response ? response.split('.') : [];

      if (!api) return;

      return this.axios(api, { params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, {
          page: this.page && this.page > 1 ? this.page : 1
        }) }).then(function (response) {
        if (response.data) {
          _this2.newList = response;
          for (var i in responseObject) {
            _this2.newList = _this2.newList[responseObject[i]] ? _this2.newList[responseObject[i]] : [];
          }

          if (_this2.newList && _this2.newList.length > 0) {
            for (var _i = 0; _i < _this2.newList.length; _i++) {
              _this2.list.push(_this2.newList[_i]);
            }
          }
          _this2.$emit('change', _this2.list);
          _this2.$emit('input', _this2.list);
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(response);
      }).catch(function (error) {
        _this2.error = '服务器错误';
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    refresh: function refresh() {
      var _this3 = this;

      if (!this.status.loading) {
        this.status.loading = true;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
        this.getList().then(function (response) {
          _this3.status.loading = false;
          _this3.$emit('on-refresh', response);
        }).catch(function (error) {
          _this3.status.loading = false;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
        });
      }
    },
    infinite: function infinite() {
      var _this4 = this;

      if (!this.status.infiniting && this.status.isInfinite) {
        this.status.infiniting = true;
        this.page++;
        this.getList().then(function (response) {
          if (!_this4.newList || _this4.newList.length < 1) {
            _this4.page--;
            _this4.status.isInfinite = false;
          }
          _this4.status.infiniting = false;
        }).catch(function (error) {
          _this4.page--;
          _this4.status.infiniting = false;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
        });
      }
    },
    onScroll: function onScroll(e) {
      this.status.top = this.$refs.scrollContainer.scrollTop;
      if (this.status.loading || !this.status.isInfinite || this.status.infiniting) {
        return;
      }
      var outerHeight = this.$refs.scrollContainer.clientHeight;
      var innerHeight = this.$el.querySelector('.inner').clientHeight;
      var scrollTop = this.$refs.scrollContainer.scrollTop;
      var bottom = innerHeight - outerHeight - scrollTop;
      if (innerHeight > outerHeight && bottom <= 10) {
        this.infinite();
      }
    },
    onInfinite: function onInfinite() {}
  },

  activated: function activated() {
    this.$refs.scrollContainer.scrollTop = this.status.top;
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_parse_content__ = __webpack_require__(58);

var parsePlain = function parsePlain(str, len) {
  var rel = str ? str.replace(/<[^<>]+?>/g, '') : '';
  return len && rel && rel.length > len ? rel.substring(0, len) + '...' : rel;
};

var parseSimple = function parseSimple(str, len) {
  return str ? str.replace(/\r/g, '&nbsp;').replace(/\n/g, '<br />') : '';
};

var parseHTML = function parseHTML(str, len) {
  return str;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    enter: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'plain'
    },
    length: {
      type: Number
    },
    value: null
  },
  methods: {
    parseContent: __WEBPACK_IMPORTED_MODULE_0__tools_parse_content__["a" /* default */] },
  computed: {
    currentValue: function currentValue() {
      switch (this.type) {
        case 'plain':
          return this.parseContent(parsePlain(this.value, this.length));
        case 'html':
          return this.parseContent(parseHTML(this.value, this.length));
        case 'simple':
          return this.parseContent(parseSimple(this.value, this.length));
        default:
          return this.parseContent(parsePlain(this.value, this.length));
      }
    }
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabbar__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tabbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template_scroll__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__template_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__new_message__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__new_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__new_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list_item__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__list_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_util__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tools_device__ = __webpack_require__(55);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tabbar: __WEBPACK_IMPORTED_MODULE_0__Tabbar___default.a,
    Scroll: __WEBPACK_IMPORTED_MODULE_1__template_scroll___default.a,
    NewMessage: __WEBPACK_IMPORTED_MODULE_2__new_message___default.a,
    FeedListItem: __WEBPACK_IMPORTED_MODULE_3__list_item___default.a,
    wxShares: __WEBPACK_IMPORTED_MODULE_7__tools_util__["c" /* wxShares */]
  },
  data: function data() {
    return {
      list: [],
      scrollVal: 0,
      addShow: true,
      time: null,
      wxShareData: {
        title: '',
        link: '',
        desc: '',
        imgUrl: ''
      },
      number: 0
    };
  },
  methods: {
    initData: function initData() {
      this.initFeed();
      this.getMessage();
      this.initWechat();
      this.getAdvList();
    },
    getMessage: function getMessage() {
      var _this = this;

      this.axios.get(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].user.notifyNum).then(function (response) {
        if (response.data.data) {
          _this.number = response.data.data.comment_num + response.data.data.credit_num + response.data.data.notify_num;
        }
      });
    },
    initFeed: function initFeed() {
      this.$refs.scrollComponent.init({
        api: __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].feed.list,
        params: {
          type: this.type
        },
        response: 'data.data.list'
      });
    },
    getAdvList: function getAdvList() {
      this.axios.get(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].adv.list, {
        params: {
          name: 'feed-list-index'
        }
      }).then(function (response) {
        if (response.data.code === 200) {
          console.log(1);
        }
      });
    },
    initWechat: function initWechat() {
      var url = window.sessionStorage.getItem('initUrl') || window.location.href;
      var targetUrl = window.location.href;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tools_device__["b" /* isIOS */])()) {
        this.wxShareData.title = '房车圈';
        this.wxShareData.imgUrl = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].feedShareImage;
        this.wxShareData.desc = '华人21世纪房车的达人都在这里了，21世纪房车，喜欢就一起来';
        this.wxShareData.link = targetUrl;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tools_util__["c" /* wxShares */])(this.wxShareData);
      } else {
        this.axios.post(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].rv.wxcode, { url: url }).then(function (response) {
          if (response.data.code === 200) {
            __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.config({
              debug: false,
              appId: response.data.data.appid,
              timestamp: response.data.data.timestamp,
              nonceStr: response.data.data.noncestr,
              signature: response.data.data.signature,
              jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline']
            });
            __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.ready(function () {
              __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.onMenuShareAppMessage({
                title: '房车圈',
                desc: '华人21世纪房车的达人都在这里了，21世纪房车，喜欢就一起来',
                link: targetUrl,
                imgUrl: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].feedShareImage,
                success: function success(res) {},
                cancel: function cancel(res) {}
              });

              __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.onMenuShareTimeline({
                title: '房车圈 - 21世纪房车的达人都在这里了，21世纪房车，喜欢就一起来',
                link: targetUrl,
                imgUrl: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].feedShareImage,
                success: function success(res) {},
                cancel: function cancel(res) {}
              });
            });
            __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.error(function (res) {});
          }
        });
      }
    },
    doScroll: function doScroll() {
      clearTimeout(this.time);
      var scrollValue = document.getElementsByClassName('app-container')[0].scrollTop;
      if (scrollValue > 0) {
        if (this.scrollVal < scrollValue) {
          this.addShow = false;
        } else if (this.scrollVal > scrollValue) {
          this.addShow = true;
        }
      } else {
        this.addShow = true;
      }
      this.scrollVal = scrollValue;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        _this2.initData();
      } else {
        window.location.href = 'https://www.wanfangche.com';
      }
    });
    if (document.getElementsByClassName('app-container').length > 0) {
      document.getElementsByClassName('app-container')[0].addEventListener('scroll', this.doScroll);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (document.getElementsByClassName('app-container').length > 0) {
      document.getElementsByClassName('app-container')[0].removeEventListener('scroll', this.doScroll);
    }
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_parse_content__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__feed_content__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__feed_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__feed_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(9);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VideoView: __WEBPACK_IMPORTED_MODULE_3__components__["a" /* VideoView */],
    ImageGroup: __WEBPACK_IMPORTED_MODULE_3__components__["b" /* ImageGroup */],
    TextView: __WEBPACK_IMPORTED_MODULE_3__components__["c" /* TextView */],
    Gender: __WEBPACK_IMPORTED_MODULE_3__components__["d" /* Gender */],
    FeedContent: __WEBPACK_IMPORTED_MODULE_4__feed_content___default.a,
    AliPlay: __WEBPACK_IMPORTED_MODULE_3__components__["e" /* AliPlay */]
  },
  props: {
    value: {}
  },
  data: function data() {
    return {
      list: [],
      follow: '关注',
      xing: [1, 2, 3, 4, 5],
      query: {
        type: undefined
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    currentUser: 'currentUser',
    isLoggedin: 'isLoggedin'
  }), {
    videoHeight: function videoHeight() {
      return (this.$el.clientWidth - 30) * 9 / 16 + 2;
    }
  }),
  methods: {
    parseContent: __WEBPACK_IMPORTED_MODULE_2__tools_parse_content__["a" /* default */], checkAuth: function checkAuth() {
      if (!this.isLoggedin) {
        this.$router.push({ name: 'user_login' });
        return false;
      } else {
        return true;
      }
    },
    onItemClick: function onItemClick(e, item) {
      var tag = e.target.getAttribute('tag');
      console.log(tag, e);
      if (tag) {
        this.$router.push({ name: 'feed_topic_redirect', params: { key: tag } });
      } else {
        this.$router.push({ name: 'feed_detail', params: { id: item.id } });
      }
    },
    userLink: function userLink(item) {
      this.$router.push({ name: 'u_home', params: { u_id: item.author.id } });
    },
    campLink: function campLink(item) {
      this.$router.push({ name: 'camp_detail', params: { id: item.camp_detail.uuid }, query: { type: item.camp_detail.type } });
    },
    campBtn: function campBtn(item) {
      this.$router.push({ name: 'camp_detail', params: { id: item } });
    },
    locationLink: function locationLink(item) {
      window.location.href = 'http://map.wanfangche.com/?lat=' + item.lat + '&lng=' + item.lon;
    },
    goArticle: function goArticle(item) {
      if (window.location.href.indexOf('t.m') !== -1 || window.location.href.indexOf('localhost') !== -1) {
        window.location.href = 'https://apps.wanfangche.com/article?id=' + item.id;
      } else {
        window.location.href = 'https://apps.21rv.com/article?id=' + item.id;
      }
    },
    goTopic: function goTopic(name) {
      this.$router.push({ name: 'feed_topic_redirect', params: { key: name } });
    },
    goCms: function goCms(item) {
      if (window.location.href.indexOf('t.m') !== -1 || window.location.href.indexOf('localhost') !== -1) {
        window.location.href = 'https://apps.wanfangche.com/information?id=' + item.id;
      } else {
        window.location.href = 'https://apps.21rv.com/information?id=' + item.id;
      }
    },
    thumbUp: function thumbUp(item) {
      if (this.checkAuth()) {
        item.is_follow = item.is_follow ? 0 : 1;
        this.axios.post(__WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].feed.like, {
          id: item.id
        }).then(function (response) {
          if (response.status === 200 && response.data.code === 1) {
            response.data.data === -1 ? item.credit_num -= 1 : item.credit_num += 1;
          }
        });
      }
    },
    doFollow: function doFollow(item) {
      if (this.checkAuth()) {
        if (item.author.is_follow === 0) {
          item.author.is_follow = 2;
          for (var i = 0; i < this.list.length; i++) {
            if (item.author.id === this.list[i].author.id) {
              this.list[i].author.is_follow = 2;
            }
          }
        } else {
          item.author.is_follow = 0;
          for (var _i = 0; _i < this.list.length; _i++) {
            if (item.author.id === this.list[_i].author.id) {
              this.list[_i].author.is_follow = 0;
            }
          }
        }
        this.axios.post(__WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].feed.follow, {
          uid: this.currentUser.user_id,
          id: item.author.id,
          accesstoken: ''
        }).then(function (response) {});
      }
    },
    doDelete: function doDelete(item, index) {
      var r = confirm('确定删除？');
      if (r) {
        this.list.splice(index, 1);
        if (item.author && parseInt(item.author.id) === parseInt(this.currentUser.user_id)) {
          this.axios.post(__WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].feed.delete, { id: item.id });
        }
      }
    },
    albumView: function albumView(src, list) {
      if (window.WeixinJSBridge) {
        window.WeixinJSBridge.invoke('imagePreview', {
          'urls': list.map(function (src) {
            return src + __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].ossimage.xlarge;
          }),
          'current': src + __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].ossimage.xlarge
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.query = _this.$route.query;
      _this.list = _this.value;
    });
  },

  watch: {
    value: function value(val) {
      this.list = val;
      this.list.map(function (val) {
        if (val.img.length > 3) {
          val.imgs = val.img.slice(0, 3);
        }
      });
    }
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      number: 0
    };
  },
  methods: {
    initData: function initData() {
      var _this = this;

      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].user.notifyNum).then(function (response) {
        if (response.data.data) {
          console.log();
          _this.number = response.data.data.comment_num + response.data.data.credit_num + response.data.data.notify_num;
        }
      });
    }
  },
  created: function created() {
    this.initData();
  }
});

/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wfc__calendar"
  }, [_c('div', {
    staticClass: "calendar-header"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("清除")])]), _vm._v(" "), _c('div', {
    staticClass: "h-box"
  }, [_vm._v("取车时间："), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-xlg"
  }, [_vm._v(_vm._s(_vm.query.startDate))])]), _vm._v(" "), _c('div', {
    staticClass: "h-box"
  }, [_vm._v("还车时间:"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-xlg"
  }, [_vm._v(_vm._s(_vm.query.endDate))])]), _vm._v(" "), _c('div', {
    staticClass: "week-container"
  }, [_c('ul', _vm._l((['日', '一', '二', '三', '四', '五', '六']), function(w) {
    return _c('li', [_vm._v(_vm._s(w))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "calendar-body"
  }, _vm._l((_vm.list), function(m) {
    return _c('div', {
      staticClass: "month-container"
    }, [_c('div', {
      staticClass: "month-title"
    }, [_vm._v(_vm._s(m.isOtherYear ? m.year + '年' : '') + _vm._s(m.month + 1) + "月")]), _vm._v(" "), _c('ul', _vm._l((m.dates), function(item) {
      return _c('li', {
        class: {
          active: item.isActive, 'is-previous': item.isPrevious, 'is-weekend': item.isWeekend, 'is-other-month': item.isOtherMonth
        },
        on: {
          "click": function($event) {
            return _vm.onDateClick(item)
          }
        }
      }, [_c('div', {
        staticClass: "date-container"
      }, [_vm._v(_vm._s(item.date))])])
    }), 0)])
  }), 0), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-footer"
  }, [_c('div', {
    staticClass: "padder-v text-center"
  }, [_c('a', {
    staticClass: "btn btn-custom btn-lg"
  }, [_vm._v("保存")])])])
}]}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-view",
    domProps: {
      "innerHTML": _vm._s(_vm.currentValue)
    }
  }, [_vm._v("\n  " + _vm._s(_vm.currentValue) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-dot-move"
  }, [_c('div', {
    staticClass: "loading-dot-move-circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-dot-move-circle2"
  })])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.number > 0),
      expression: "number > 0"
    }],
    staticClass: "text-center clear m-t"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-border text-normal btn-rounded",
    attrs: {
      "to": {
        name: 'user_message'
      }
    }
  }, [_vm._v(_vm._s(_vm.number) + "条新消息")])], 1)
},staticRenderFns: []}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.className,
    attrs: {
      "for": _vm.name
    }
  }, [_c('input-file'), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-view"
  }, [(_vm.iframeLink) ? _c('div', [_c('iframe', {
    attrs: {
      "frameborder": "0",
      "width": "100%",
      "height": _vm.height,
      "src": _vm.iframeLink,
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mp4Link) ? _c('div', [_c('video-player', {
    attrs: {
      "src": _vm.mp4Link,
      "width": _vm.width,
      "height": _vm.height,
      "poster": _vm.poster
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollContainer",
    staticClass: "app-container",
    on: {
      "scroll": function($event) {
        return _vm.onScroll($event)
      }
    }
  }, [_c('div', {
    staticClass: "app-wrapper inner bg-light"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "scroll-more-container"
  }, [_c('div', {
    staticClass: "btn btn-block text-center text-muted"
  }, [(!_vm.status.infiniting && !_vm.status.isInfinite) ? _c('span', [_vm._v("没有更多了")]) : _vm._e(), _vm._v(" "), (!_vm.status.infiniting && _vm.status.isInfinite && !_vm.status.loading) ? _c('span') : _vm._e(), _vm._v(" "), (_vm.status.infiniting) ? _c('span', [_vm._v("加载中...")]) : _vm._e()])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  ca\n")])
},staticRenderFns: []}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.objClass) ? _c('i', {
    class: _vm.objClass
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-rv"
  }, [_c('div', {
    staticClass: "loading-rv-bg"
  }, [_c('div', {
    staticClass: "loading-rv-sand"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-cloud1"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-cloud2"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-cloud3"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-mountain"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-tree1"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-car-container"
  }, [_c('div', {
    staticClass: "loading-rv-wheel-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-car"
  }, [_c('div', {
    staticClass: "loading-rv-wheel loading-rv-wheel-front"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-wheel loading-rv-wheel-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-car-shadow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-tree2"
  })])])
}]}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed-lists"
  }, _vm._l((_vm.list), function(item, index) {
    return (item) ? _c('div', {
      staticClass: "feed-list-item no-radius",
      on: {
        "click": function($event) {
          return _vm.onItemClick($event, item)
        }
      }
    }, [(item.author) ? _c('div', {
      staticClass: "media",
      class: {
        'essence': item.is_essence === 1
      }
    }, [_c('div', {
      staticClass: "text-normal relative",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.userLink(item)
        }
      }
    }, [_c('div', {
      staticClass: "pull-left avatar m-r avatar-lg avatar-circle",
      class: {
        'bg-color': !item.author.avatar
      }
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.author.avatar, 'avatar')
      }
    })]), _vm._v(" "), (item.author.isrv == 1) ? _c('div', {
      staticClass: "is-certify"
    }, [_c('img', {
      attrs: {
        "src": "https://img01.wanfangche.com/public/upload/201804/13/5ad0552c60b29.png?x-oss-process=style/large",
        "alt": "认证车主",
        "width": "100%",
        "height": "100%"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [(_vm.currentUser.user_id && _vm.currentUser.user_id != item.author.id) ? _c('div', {
      staticClass: "pull-right text-center text-muted"
    }, [(item.author.is_follow == 0) ? _c('a', {
      staticClass: "btn btn-follow",
      class: {
        'feed-followed': item.author.is_follow == 1
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.doFollow(item)
        }
      }
    }, [_vm._v("\n        关注")]) : _vm._e(), _vm._v(" "), (item.author.is_follow == 2) ? _c('a', {
      staticClass: "btn btn-follow",
      class: {
        'feed-followed': item.author.is_follow == 2
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.doFollow(item)
        }
      }
    }, [_vm._v("\n        已关注")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text-normal feed-list-name1",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.userLink(item)
        }
      }
    }, [_c('div', {
      staticClass: "text-bolder text-md"
    }, [_vm._v(_vm._s(item.author.nickname || '车友')), _c('gender', {
      model: {
        value: (item.author.sex),
        callback: function($$v) {
          _vm.$set(item.author, "sex", $$v)
        },
        expression: "item.author.sex"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "text-muted text-small m-t-3"
    }, [_vm._v(_vm._s(item.publish_time || item.publish_date))])])])]) : _vm._e(), _vm._v(" "), (item.content) ? _c('div', {
      staticClass: "feed-content block",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onItemClick($event, item)
        }
      }
    }, [_c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.topic_name),
        expression: "item.topic_name"
      }],
      staticClass: "feed_content_tag",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goTopic(item.topic_name)
        }
      }
    }, [_vm._v("#" + _vm._s(item.topic_name) + "#")]), _vm._v(" "), _c('feed-content', {
      staticClass: "text-lg m-t-sm text-normal",
      attrs: {
        "type": "plain",
        "length": 140
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }), _vm._v(" "), (item.content.length >= 103) ? _c('a', [_vm._v("全文")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type >= 3 && item.post_detail && item.post_detail.type == 0) ? _c('div', {
      staticClass: "feed-content block feed-contents",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onItemClick($event, item.post_detail)
        }
      }
    }, [_c('span', {
      staticClass: "feed_content_tag"
    }, [_vm._v("@" + _vm._s(item.post_detail.author.nickname) + ":")]), _vm._v(" "), _c('feed-content', {
      staticClass: "text-lg m-t-sm text-normal",
      attrs: {
        "type": "plain",
        "length": 140
      },
      model: {
        value: (item.post_detail.content),
        callback: function($$v) {
          _vm.$set(item.post_detail, "content", $$v)
        },
        expression: "item.post_detail.content"
      }
    }), _vm._v(" "), (item.content.length >= 103) ? _c('a', [_vm._v("全文")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type == 4 && item.cms_detail && item.cms_detail.content) ? _c('div', {
      staticClass: "feed-content block feed-contents"
    }, [_c('span', {
      staticClass: "feed_content_tag"
    }, [_vm._v("@" + _vm._s(item.cms_detail.author.nickname) + ":")]), _vm._v(" "), _c('feed-content', {
      staticClass: "text-lg m-t-sm text-normal",
      attrs: {
        "type": "plain",
        "length": 140
      },
      model: {
        value: (item.cms_detail.content),
        callback: function($$v) {
          _vm.$set(item.cms_detail, "content", $$v)
        },
        expression: "item.cms_detail.content"
      }
    }), _vm._v(" "), (item.content.length >= 103) ? _c('a', [_vm._v("全文")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type >= 3 && item.post_detail && (item.post_detail.type == 1 || item.post_detail.type == 2)) ? _c('div', {
      staticClass: "feed-share-container"
    }, [_c('div', {
      staticClass: "feed-share no-radius",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.campLink(item.post_detail)
        }
      }
    }, [_c('div', {
      staticClass: "pull-left share-info-img m-r feed-item-camp"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.post_detail.camp_detail.imgpath, 'small'),
        "width": "100%"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "camp-list-item"
    }, [_c('div', {
      staticClass: "text-md text-bolder share-info-name over-omit"
    }, [_vm._v(_vm._s(item.post_detail.camp_detail.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-muted share-info-others m-b-3",
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('p', {
      staticClass: "camp-xing"
    }, _vm._l((_vm.xing), function(items) {
      return _c('i', {
        staticClass: "icon-camp-collection",
        class: {
          'actives': items <= item.post_detail.camp_detail.score
        }
      })
    }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.camp_detail.price))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "camp-level-icon camp-level-icons pull-left",
      class: {
        'color-camp2': item.post_detail.camp_detail.type == 1, 'color-park2': item.post_detail.camp_detail.type == 0, 'color-scenic2': item.post_detail.camp_detail.type == 2, 'color-food2': item.post_detail.camp_detail.type == 3, 'color-fix2': item.post_detail.camp_detail.type == 4, 'color-refuel2': item.post_detail.camp_detail.type == 5
      }
    }, [_c('span', {
      class: {
        'icon-camp-camp': item.post_detail.camp_detail.type == 1, 'icon-camp-park': item.post_detail.camp_detail.type == 0, 'icon-camp-scenic': item.post_detail.camp_detail.type == 2, 'icon-camp-food': item.post_detail.camp_detail.type == 3, 'icon-camp-service': item.post_detail.camp_detail.type == 4, 'icon-camp-station': item.post_detail.camp_detail.type == 5
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "camp-level-txt camp-level-txts pull-left text-sm",
      class: {
        'color-camp1': item.post_detail.camp_detail.type == 1, 'color-park1': item.post_detail.camp_detail.type == 0, 'color-scenic1': item.post_detail.camp_detail.type == 2, 'color-food1': item.post_detail.camp_detail.type == 3, 'color-fix1': item.post_detail.camp_detail.type == 4, 'color-refuel1': item.post_detail.camp_detail.type == 5
      }
    }, [_vm._v("\n            " + _vm._s(item.post_detail.camp_detail.scale) + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), (item.type == 2 || item.type == 1) ? _c('div', {
      staticClass: "feed-share-container"
    }, [_c('div', {
      staticClass: "feed-share no-radius",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.campLink(item)
        }
      }
    }, [_c('div', {
      staticClass: "pull-left share-info-img m-r feed-item-camp"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.camp_detail.imgpath, 'small'),
        "width": "100%"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "camp-list-item"
    }, [_c('div', {
      staticClass: "text-md text-bolder share-info-name over-omit"
    }, [_vm._v(_vm._s(item.camp_detail.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-muted share-info-others m-b-3",
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('p', {
      staticClass: "camp-xing"
    }, _vm._l((_vm.xing), function(items) {
      return _c('i', {
        staticClass: "icon-camp-collection",
        class: {
          'actives': items <= item.camp_detail.score
        }
      })
    }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.camp_detail.price))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "camp-level-icon camp-level-icons pull-left",
      class: {
        'color-camp2': item.camp_detail.type == 1, 'color-park2': item.camp_detail.type == 0, 'color-scenic2': item.camp_detail.type == 2, 'color-food2': item.camp_detail.type == 3, 'color-fix2': item.camp_detail.type == 4, 'color-refuel2': item.camp_detail.type == 5
      }
    }, [_c('span', {
      class: {
        'icon-camp-camp': item.camp_detail.type == 1, 'icon-camp-park': item.camp_detail.type == 0, 'icon-camp-scenic': item.camp_detail.type == 2, 'icon-camp-food': item.camp_detail.type == 3, 'icon-camp-service': item.camp_detail.type == 4, 'icon-camp-station': item.camp_detail.type == 5
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "camp-level-txt camp-level-txts pull-left text-sm",
      class: {
        'color-camp1': item.camp_detail.type == 1, 'color-park1': item.camp_detail.type == 0, 'color-scenic1': item.camp_detail.type == 2, 'color-food1': item.camp_detail.type == 3, 'color-fix1': item.camp_detail.type == 4, 'color-refuel1': item.camp_detail.type == 5
      }
    }, [_vm._v("\n            " + _vm._s(item.camp_detail.scale) + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), (item.video) ? _c('div', {
      staticClass: "text-center video-padder"
    }, [_c('video-view', {
      attrs: {
        "src": item.video,
        "allowfullscreen": ""
      }
    })], 1) : (item.video_object) ? _c('div', {
      staticClass: "text-center video-padder"
    }, [_c('video-view', {
      attrs: {
        "src": item.video_object.src,
        "poster": item.video_object.poster || '',
        "allowfullscreen": ""
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type == 7 && item.post_detail.type == 0 && item.post_detail.video) ? _c('div', {
      staticClass: "text-center video-padder feed-contents top-0"
    }, [_c('video-view', {
      attrs: {
        "src": item.post_detail.video,
        "allowfullscreen": ""
      }
    })], 1) : (item.type == 7 && item.post_detail.type == 0 && item.post_detail.video_object) ? _c('div', {
      staticClass: "text-center video-padder feed-contents top-0"
    }, [_c('video-view', {
      attrs: {
        "src": item.post_detail.video_object.src,
        "poster": item.post_detail.video_object.poster || '',
        "allowfullscreen": ""
      }
    })], 1) : _vm._e(), _vm._v(" "), ((item.type == 3 || item.type == 5) && item.cms_detail) ? _c('div', {
      staticClass: "text-center video-padder feed-contents",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goCms(item.cms_detail)
        }
      }
    }, [_c('div', {
      staticClass: "article-content"
    }, [_c('span', {
      staticClass: "feed_content_tag"
    }, [_vm._v("@" + _vm._s(item.cms_detail.author.nickname) + ":")]), _vm._v(" "), _c('feed-content', {
      staticClass: "text-lg m-t-sm text-normal",
      attrs: {
        "type": "plain",
        "length": 40
      },
      model: {
        value: (item.cms_detail.title),
        callback: function($$v) {
          _vm.$set(item.cms_detail, "title", $$v)
        },
        expression: "item.cms_detail.title"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "article-poster"
    }, [_c('img', {
      attrs: {
        "src": item.cms_detail.poster || 'https://img01.wanfangche.com/public/upload/201908/27/5d64e4d1e3a9a.png?x-oss-process=style/middle',
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (item.type == 6 && item.article_detail) ? _c('div', {
      staticClass: "text-center video-padder feed-contents",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goArticle(item.article_detail)
        }
      }
    }, [_c('div', {
      staticClass: "article-content"
    }, [_c('span', {
      staticClass: "feed_content_tag"
    }, [_vm._v("@" + _vm._s(item.article_detail.author.nickname) + ":")]), _vm._v(" "), _c('feed-content', {
      staticClass: "text-lg m-t-sm text-normal",
      attrs: {
        "type": "plain",
        "length": 40
      },
      model: {
        value: (item.article_detail.title),
        callback: function($$v) {
          _vm.$set(item.article_detail, "title", $$v)
        },
        expression: "item.article_detail.title"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "article-poster"
    }, [_c('img', {
      attrs: {
        "src": item.article_detail.poster || 'https://img01.wanfangche.com/public/upload/201908/27/5d64e4d1e3a9a.png?x-oss-process=style/middle',
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (item.type == 4 && item.cms_detail) ? _c('div', {
      staticClass: "text-center video-padder feed-contents top-0 ",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goCms(item.cms_detail)
        }
      }
    }, [_c('div', {
      staticClass: "article-video-poster"
    }, [_c('img', {
      attrs: {
        "src": item.cms_detail.poster,
        "alt": ""
      }
    }), _vm._v(" "), _c('span')])]) : _vm._e(), _vm._v(" "), (item.type == 7 && item.post_detail.type == 0 && item.post_detail.img.length > 0 && (!item.post_detail.video_object && !item.post_detail.video)) ? _c('a', {
      staticClass: "block feed-contents top-0",
      class: {
        'p-t-4': item.post_detail.video, 'p-b-4': item.post_detail.video
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onItemClick($event, item.post_detail)
        }
      }
    }, [(item.post_detail.video) ? _c('div', [(item.post_detail.img && item.post_detail.img.length < 2 && item.post_detail.img[0]) ? _c('div', {
      staticClass: "img-full img-cover"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.post_detail.img[0], 'middle')
      }
    })]) : _vm._e(), _vm._v(" "), (item.post_detail.img.length > 1 && item.post_detail.img.length < 4) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, _vm._l((item.post_detail.img), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (item.post_detail.img.length > 3) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, [_vm._l((item.post_detail.imgs), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), _vm._v(" "), _c('a', {
      staticClass: "col-xs-4 feed-item-img",
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "row thumb-feed-img feed-img-text"
    }, [_c('div', {
      staticClass: "feed-img-modal"
    }, [_vm._v("+" + _vm._s(item.post_detail.img.length - 3))])])])], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.post_detail.video) ? _c('div', {
      class: {
        'p-t-4': item.post_detail.img.length == 1, 'p-b-4': item.post_detail.img.length == 1
      }
    }, [(item.post_detail.img && item.post_detail.img.length < 2 && item.post_detail.img[0]) ? _c('div', {
      staticClass: "img-full img-cover"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.post_detail.img[0], 'middle')
      }
    })]) : _vm._e(), _vm._v(" "), (item.post_detail.img.length > 1) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, _vm._l((item.post_detail.img), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img1"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), 0) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.img.length > 0) ? _c('router-link', {
      staticClass: "block",
      class: {
        'p-t-4': item.video, 'p-b-4': item.video
      },
      attrs: {
        "to": {
          name: 'feed_detail',
          params: {
            id: item.id
          }
        }
      }
    }, [(item.video) ? _c('div', [(item.img && item.img.length < 2 && item.img[0]) ? _c('div', {
      staticClass: "img-full img-cover"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.img[0], 'middle')
      }
    })]) : _vm._e(), _vm._v(" "), (item.img.length > 1 && item.img.length < 4) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, _vm._l((item.img), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (item.img.length > 3) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, [_vm._l((item.imgs), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), _vm._v(" "), _c('a', {
      staticClass: "col-xs-4 feed-item-img",
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "row thumb-feed-img feed-img-text"
    }, [_c('div', {
      staticClass: "feed-img-modal"
    }, [_vm._v("+" + _vm._s(item.img.length - 3))])])])], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.video) ? _c('div', {
      class: {
        'p-t-4': item.img.length == 1, 'p-b-4': item.img.length == 1
      }
    }, [(item.img && item.img.length < 2 && item.img[0]) ? _c('div', {
      staticClass: "img-full img-cover"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossResize")(item.img[0], 'middle')
      }
    })]) : _vm._e(), _vm._v(" "), (item.img.length > 1) ? _c('div', {
      staticClass: "clear feed-item-imgs"
    }, _vm._l((item.img), function(image, index) {
      return _c('a', {
        staticClass: "col-xs-4",
        staticStyle: {
          "overflow": "hidden"
        }
      }, [(image) ? _c('div', {
        staticClass: "row thumb-feed-img1"
      }, [_c('img', {
        staticClass: "preview-img",
        staticStyle: {
          "height": "auto"
        },
        attrs: {
          "src": _vm._f("ossResize")(image, 'small'),
          "alt": ""
        }
      })]) : _vm._e()])
    }), 0) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.camp_name) ? _c('div', {
      staticClass: "block p-t-4 p-b-4"
    }, [_c('a', {
      staticClass: "camp-min font-12 over-omit",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.campBtn(item.camp_id)
        }
      }
    }, [_c('i', {
      staticClass: "icon"
    }), _c('span', [_vm._v(_vm._s(item.camp_name))])])]) : _vm._e(), _vm._v(" "), (item.address) ? _c('div', {
      staticClass: "block p-t-4 p-b-4"
    }, [_c('a', {
      staticClass: "location-show font-12 over-omit",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.locationLink(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa icon-camp-address m-r"
    }), _vm._v(_vm._s(item.address) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clear block feed-item-candle m-t-8",
      class: {
        'border-none': item.type >= 3
      }
    }, [_c('div', {
      staticClass: "btn-group pull-right m-t-8 text-muted m-r--12"
    }, [_c('router-link', {
      staticClass: "table-box text-xlg btn text-muted text-top p-r-0",
      attrs: {
        "to": {
          name: 'feed_detail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "text-xlg fd-comment table-cell "
    }), _vm._v(" "), _c('span', {
      staticClass: "text-md table-cell padder-xs no-line-height p-r-0 comment-width"
    }, [_vm._v(_vm._s(item.reply_num || ''))])]), _vm._v(" "), _c('a', {
      staticClass: "btn  no-hover table-box",
      class: item.is_follow === 1 ? 'text-default' : 'text-muted',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.thumbUp(item)
        }
      }
    }, [_c('i', {
      staticClass: "text-xlg table-cell",
      class: item.is_follow ? 'fd-thumb-up' : 'fd-thumb-o-up'
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.credit_num != 0),
        expression: "item.credit_num!=0"
      }],
      staticClass: "text-md table-cell padder-xs no-line-height"
    }, [_vm._v(_vm._s((item.credit_num && item.credit_num > 0) ? item.credit_num : ''))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "m-t-12 text-muted"
    }, [_c('span', {
      staticClass: "m-r text-md"
    }, [_vm._v(_vm._s(item.read_num) + "次浏览")])])]), _vm._v(" "), (item.post_content && item.post_content.length > 0) ? _c('div', {
      staticClass: "feed-comment-list m-t-sm"
    }, [_c('router-link', {
      staticClass: "block text-normal",
      attrs: {
        "to": {
          name: 'feed_detail',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._l((item.post_content), function(comment, index) {
      return _c('div', {
        staticClass: "feed-comment-item",
        class: {
          'p-b-0': index == (item.post_content.length - 1)
        }
      }, [(comment.author) ? _c('div', {
        staticClass: "pull-left avatar-circle avatar-xs"
      }, [_c('img', {
        attrs: {
          "src": _vm._f("ossResize")(comment.author.avatar, 'avatar')
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "media-body text-md"
      }, [_c('span', {
        staticClass: "text-lt text-bold"
      }, [_vm._v(_vm._s(comment.author.nickname))]), _vm._v(":\n          "), _c('text-view', {
        attrs: {
          "length": 100
        },
        model: {
          value: (comment.content),
          callback: function($$v) {
            _vm.$set(comment, "content", $$v)
          },
          expression: "comment.content"
        }
      })], 1)])
    }), _vm._v(" "), _c('div', {
      staticClass: "padder-v-sm p-t-7",
      class: {
        'p-t-4': item.reply_num < 4, 'p-b-4': item.reply_num < 4
      }
    }, [(item.reply_num > 3) ? _c('router-link', {
      staticClass: "block tag-color",
      attrs: {
        "to": {
          name: 'feed_detail',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("查看所有" + _vm._s(item.reply_num) + "条评论")]) : _vm._e()], 1)], 2)], 1) : _vm._e()], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-footer"
  }, [_c('div', {
    staticClass: "footer-tabbar"
  }, [_c('router-link', {
    staticClass: "tabbar-item",
    attrs: {
      "to": {
        name: 'rental'
      },
      "exact": ""
    }
  }, [_c('div', {
    staticClass: "tabbar-item-icon-text"
  }, [_c('span', {
    staticClass: "icon-rantel-normal icon-default"
  }, [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  }), _c('span', {
    staticClass: "path3"
  }), _c('span', {
    staticClass: "path4"
  })]), _vm._v(" "), _c('span', {
    staticClass: "icon-rantel-selected icon-active"
  }, [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  }), _c('span', {
    staticClass: "path3"
  }), _c('span', {
    staticClass: "path4"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tabbar-item-label"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("租车")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "tabbar-item",
    attrs: {
      "to": {
        name: 'user'
      }
    }
  }, [_c('div', {
    staticClass: "tabbar-item-icon-text"
  }, [_c('span', {
    staticClass: "icon-personal-normal icon-default"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-personal-selected icon-active"
  }, [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  }), _c('span', {
    staticClass: "path3"
  }), _c('span', {
    staticClass: "path4"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tabbar-item-label"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("我的")])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-player"
  }, [_c('video', {
    staticClass: "video-js"
  })])
}]}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading",
    class: !_vm.text ? 'vux-loading-no-text' : ''
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-group"
  }, [(_vm.imageList && _vm.imageList.length === 1) ? _c('div', {
    on: {
      "click": function($event) {
        return _vm.albumView(_vm.imageList[0], _vm.imageList)
      }
    }
  }, [(_vm.imageList[0]) ? _c('img', {
    attrs: {
      "src": _vm.imageList[0] + '_middle'
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.imageList && _vm.imageList.length > 1) ? _c('div', _vm._l((_vm.imageList), function(item) {
    return _c('div', {
      staticClass: "image-group-item-container",
      style: (_vm.objStyle)
    }, [_c('div', {
      staticClass: "image-group-item",
      on: {
        "click": function($event) {
          return _vm.albumView(item, _vm.imageList)
        }
      }
    }, [(item) ? _c('img', {
      attrs: {
        "src": item + '_small'
      }
    }) : _vm._e()])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('popup', {
    staticStyle: {
      "height": "96%",
      "border-radius": "4px 4px 0 0",
      "position": "fixed",
      "max-height": "700px",
      "top": "40px"
    },
    attrs: {
      "position": "bottom",
      "show-mask": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "nav-header",
    staticStyle: {
      "position": "fixed",
      "top": "40px",
      "left": "0",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticClass: "nav-header-left"
  }, [_c('a', {
    staticClass: "nav-header-back text-default",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('span', {
    staticClass: "city-down"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "nav-header-title"
  }, [_vm._v("热门城市")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-header",
    staticStyle: {
      "padding-top": "44px",
      "overflow-y": "auto",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "wrapper bg-light",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n        当前定位城市: " + _vm._s(_vm.currentLocation.city) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "panel",
    staticStyle: {
      "min-height": "700px",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "panel-body text-lg"
  }, _vm._l((_vm.list), function(group) {
    return _c('div', {
      staticClass: "list-group list-group-underline list-group-lg"
    }, [_c('div', {
      staticClass: "text-xlg",
      staticStyle: {
        "padding-top": "20px",
        "font-family": "PingFangSC-Semibold"
      }
    }, [_vm._v(_vm._s(group.letter))]), _vm._v(" "), _vm._l((group.citylist), function(city) {
      return (city.city) ? _c('div', {
        staticClass: "list-group-item city-cityname",
        staticStyle: {
          "padding": "10px 0"
        },
        on: {
          "click": function($event) {
            return _vm.setCurrentCity(city)
          }
        }
      }, [_vm._v("\n              " + _vm._s(city.city) + "\n            ")]) : _vm._e()
    })], 2)
  }), 0)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "file-upload"
  }, [_c('div', {
    staticClass: "fileup-btn relative"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "upload-tips"
  }, [_vm._v("上传中...")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "upload-tips"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.currentValue) ? _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "src": _vm._f("ossResize")(_vm.currentValue, 'middle')
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "fileup-input",
    attrs: {
      "type": "file",
      "name": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onChange
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "file",
      "name": _vm.$parent.name,
      "id": _vm.$parent.inputId || _vm.$parent.name,
      "accept": _vm.$parent.accept,
      "capture": _vm.$parent.capture,
      "webkitdirectory": _vm.$parent.directory && _vm.$parent.features.directory,
      "directory": _vm.$parent.directory && _vm.$parent.features.directory,
      "multiple": _vm.$parent.multiple && _vm.$parent.features.html5
    },
    on: {
      "change": _vm.change
    }
  })
},staticRenderFns: []}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "nav-top"
  }, [_c('ul', {
    staticClass: "nav-inline nav-auto nav-inline-fixed"
  }, [_c('li', {
    staticClass: "message-box"
  }, [_c('router-link', {
    staticClass: "text-bold",
    attrs: {
      "to": {
        name: 'feed_follow'
      }
    }
  }, [_vm._v("关注"), _c('span', {
    staticClass: "feed-line"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.number > 0),
      expression: "number > 0"
    }],
    staticClass: "message-number"
  }, [_vm._v(_vm._s(_vm.number))])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    staticClass: "text-bold",
    attrs: {
      "to": {
        name: 'feed'
      }
    }
  }, [_vm._v("热门"), _c('span', {
    staticClass: "feed-line"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "text-bold",
    attrs: {
      "to": {
        name: 'feed_home'
      }
    }
  }, [_vm._v("最新"), _c('span', {
    staticClass: "feed-line"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "text-bold",
    attrs: {
      "to": {
        name: 'feed_used'
      }
    }
  }, [_vm._v("二手房车"), _c('span', {
    staticClass: "feed-line"
  })])], 1)])]), _vm._v(" "), _c('scroll', {
    key: "feed-list",
    ref: "scrollComponent",
    staticClass: "app-container app-container-top app-container-bottom",
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, [_c('feed-list-item', {
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadet"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShow),
      expression: "addShow"
    }],
    staticClass: "feed-add-container"
  }, [_c('router-link', {
    staticClass: "feed-add-btn",
    attrs: {
      "to": {
        name: 'feed_add'
      }
    }
  }, [_c('i', {
    staticClass: "fd-publish text-lg"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-md text-bold"
  }, [_vm._v("发圈子")])])], 1)]), _vm._v(" "), _c('tabbar', {
    attrs: {
      "active": "feed"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.popupShow) ? _c('div', {
    staticClass: "popup-modal"
  }, [_c('div', {
    staticClass: "popup-modal-mask",
    on: {
      "click": function($event) {
        _vm.popupShow = !_vm.popupShow
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-container"
  }, [_c('div', {
    staticClass: "emoji-container clear"
  }, [_c('ul', {
    staticClass: "emoji-list block clear pull-left"
  }, _vm._l((_vm.emoji), function(item) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(item)
      },
      on: {
        "click": _vm.insertEmoji
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "security-code-wrap"
  }, [_c('h2', [_vm._v("输入位置快捷码")]), _vm._v(" "), _c('span', {
    staticClass: "remove",
    on: {
      "click": function($event) {
        return _vm.hide()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "code"
    }
  }, [_c('ul', {
    staticClass: "security-code-container"
  }, _vm._l((_vm.number), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "field-wrap"
    }, [_c('i', {
      staticClass: "char-field"
    }, [_vm._v(_vm._s(_vm.value[index] || _vm.placeholder))])])
  }), 0)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "err"
  }, [_vm._v("请输入正确的快捷码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "input",
    staticClass: "input-code",
    staticStyle: {
      "ime-mode": "disabled"
    },
    attrs: {
      "id": "code",
      "name": "code",
      "type": "text",
      "maxlength": _vm.number,
      "autocorrect": "off",
      "autocomplete": "off",
      "autocapitalize": "off"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "keyup": function($event) {
        return _vm.handleInput($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-view",
    domProps: {
      "innerHTML": _vm._s(_vm.currentValue)
    }
  }, [_vm._v("\n  " + _vm._s(_vm.currentValue) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": ("vux-popup-animate-" + _vm.position)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.initialShow),
      expression: "show && !initialShow"
    }],
    staticClass: "vux-popup-dialog",
    class: [("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],
    style: (_vm.styles)
  }, [(_vm.shouldRenderBody) ? _vm._t("default") : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "allowfullscreen": ""
    }
  }, [_c('div', {
    staticClass: "prism-player",
    staticStyle: {
      "height": "195px"
    },
    attrs: {
      "id": _vm.playid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.btn()
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "j-album-upload"
  }, [_c('div', {
    staticClass: "view-box"
  }, [_vm._l((_vm.files), function(file, index) {
    return _c('div', {
      key: file.id,
      staticClass: "view-item"
    }, [_c('div', {
      staticClass: "view-item-container",
      on: {
        "click": function($event) {
          return _vm.previewImage(file)
        }
      }
    }, [(file.thumb) ? _c('img', {
      staticClass: "image-thumb",
      class: {
        'image-thumb-v': file.width > file.height
      },
      attrs: {
        "src": file.thumb
      }
    }) : _vm._e(), _vm._v(" "), (!file.success) ? _c('div', {
      staticClass: "j-album-process",
      style: ({
        height: (100 - file.progress) * .82 + 'px'
      })
    }, [_vm._v("\n        " + _vm._s(file.progress) + "%\n      ")]) : _vm._e()]), _vm._v(" "), _c('a', {
      staticClass: "remove-btn",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.$refs.upload.remove(file)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length < 9),
      expression: "files.length < 9"
    }],
    staticClass: "view-item select-button-container"
  }, [_c('div', {
    staticClass: "view-item-container"
  }, [_c('file-upload', {
    ref: "upload",
    staticClass: "select-button text-muted",
    attrs: {
      "post-action": _vm.postAction,
      "extensions": _vm.extensions,
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "drop": _vm.drop,
      "drop-directory": _vm.dropDirectory,
      "size": _vm.size,
      "thread": _vm.thread,
      "headers": _vm.headers,
      "data": _vm.data,
      "max-length": _vm.maxLength,
      "preload": _vm.preload
    },
    on: {
      "input-filter": _vm.inputFilter,
      "input-file": _vm.inputFile
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_c('div', {
    staticClass: "select-button-inner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(262)
    }
  }), _vm._v(" "), _c('p', [_vm._v("选择图片")])])])], 1)])], 2), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.toggleTransition
    },
    on: {
      "after-enter": _vm.onEnter,
      "after-leave": _vm.onLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "ui-modal ui-modal__mask",
    class: _vm.classes,
    attrs: {
      "role": _vm.role
    }
  }, [_c('div', {
    ref: "backdrop",
    staticClass: "ui-modal__wrapper",
    class: {
      'has-dummy-scrollbar': _vm.preventShift
    },
    on: {
      "click": function($event) {
        _vm.dismissOnBackdrop && _vm.closeModal($event)
      }
    }
  }, [_c('div', {
    ref: "container",
    staticClass: "ui-modal__container",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.dismissOnEsc && _vm.closeModal($event)
      }
    }
  }, [(_vm.dismissOnCloseButton && !_vm.removeCloseButton && _vm.dismissible) ? _c('a', {
    staticClass: "close-btn text-muted",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "wfc-icon-close"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui-modal__body"
  }, [_vm._t("default")], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-player"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player-box",
    attrs: {
      "options": _vm.playerOptions,
      "playsinline": true,
      "customEventName": "customstatechangedeventname"
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      },
      "statechanged": function($event) {
        return _vm.playerStateChanged($event)
      },
      "ready": _vm.playerReadied
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(293),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(232)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(245)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  "data-v-9cef5386",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(244)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  "data-v-93f46dec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(241)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(250)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(236)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 320 */,
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(98)();
// imports


// module
exports.push([module.i, ".vux-modal-open{overflow:hidden;position:fixed;width:100%}.vux-modal-open-for-container{overflow:hidden!important}", "", {"version":3,"sources":["/Users/lijianbo/Sites/m.wanfangche.com/root/node_modules/vux/src/styles/vux-modal.css"],"names":[],"mappings":"AAAA,gBACE,gBAAiB,AACjB,eAAgB,AAChB,UAAY,CACb,AACD,8BACE,yBAA2B,CAC5B","file":"vux-modal.css","sourcesContent":[".vux-modal-open {\r\n  overflow: hidden;\r\n  position: fixed;\r\n  width: 100%;\r\n}\r\n.vux-modal-open-for-container {\r\n  overflow: hidden!important;\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ })
],[147]);


// WEBPACK FOOTER //
// static/js/app.a0fc2db7f9365c2678ef.js